(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Build-to-perform"] && !Shopify.designMode) return;
  try {
    
(() => {
  const namespace = 'GymhawkPerformanceReviews';
  const version = '2.0.0';
  const openModalRoots = new Set();

  const existing = window[namespace];
  if (existing?.version === version) {
    existing.initAll(document);
    return;
  }

  const collectRoots = (scope) => {
    if (!scope) return [];
    const roots = [];
    if (scope.matches?.('[data-gh-performance-reviews]')) roots.push(scope);
    scope.querySelectorAll?.('[data-gh-performance-reviews]').forEach((root) => roots.push(root));
    return roots;
  };

  const getFocusable = (container) => {
    if (!container) return [];
    return [...container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.getClientRects().length > 0);
  };

  const initRoot = (root) => {
    if (!root) return;

    root._ghPerformanceController?.abort?.();

    const controller = new AbortController();
    const { signal } = controller;
    root._ghPerformanceController = controller;

    const viewport = root.querySelector('[data-gh-performance-viewport]');
    const track = root.querySelector('[data-gh-performance-track]');
    const sourceGroup = root.querySelector('[data-gh-performance-source-group]');
    const openButton = root.querySelector('[data-gh-performance-open]');
    const modal = root.querySelector('[data-gh-performance-modal]');
    const dialog = root.querySelector('[data-gh-performance-dialog]');
    const closeButtons = [...root.querySelectorAll('[data-gh-performance-close]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let resizeObserver = null;
    let approachObserver = null;
    let visibilityObserver = null;
    let resizeFrame = 0;
    let hasApproachedViewport = false;
    let lastFocused = null;
    let inertNodes = [];

    const removeLoopClones = () => {
      track?.querySelectorAll('.gh-performance-reviews__group--duplicate').forEach((group) => group.remove());
      root.classList.remove('is-loop-ready');
    };

    const createLoopClone = () => {
      if (!sourceGroup) return null;

      const clone = sourceGroup.cloneNode(true);
      clone.removeAttribute('data-gh-performance-source-group');
      clone.classList.add('gh-performance-reviews__group--duplicate');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    };

    const rebuildLoop = () => {
      resizeFrame = 0;
      if (!viewport || !track || !sourceGroup) return;

      removeLoopClones();

      if (reducedMotion.matches || !hasApproachedViewport) {
        root.style.setProperty('--gh-loop-distance', '0px');
        return;
      }

      const groupWidth = sourceGroup.getBoundingClientRect().width;
      const viewportWidth = viewport.getBoundingClientRect().width;

      if (groupWidth <= 0 || viewportWidth <= 0) return;

      const totalGroups = Math.min(
        12,
        Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1)
      );

      for (let index = 1; index < totalGroups; index += 1) {
        const clone = createLoopClone();
        if (clone) track.appendChild(clone);
      }

      root.style.setProperty('--gh-loop-distance', `-${groupWidth}px`);
      root.classList.add('is-loop-ready');
    };

    const scheduleLoopRebuild = () => {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(rebuildLoop);
    };

    const setBackgroundInert = (enabled) => {
      if (!modal) return;

      if (!enabled) {
        inertNodes.forEach((node) => {
          if (node?.isConnected) node.inert = false;
        });
        inertNodes = [];
        return;
      }

      inertNodes = [];
      let current = modal;

      while (current?.parentElement && current !== document.body) {
        const parent = current.parentElement;
        [...parent.children].forEach((sibling) => {
          if (sibling === current || sibling.inert) return;
          if (['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) return;
          sibling.inert = true;
          inertNodes.push(sibling);
        });
        current = parent;
      }
    };

    const syncBodyModalState = () => {
      document.body.classList.toggle('gh-performance-modal-open', openModalRoots.size > 0);
    };

    const openModal = () => {
      if (!modal || !dialog || !openButton || !modal.hidden) return;

      lastFocused = document.activeElement;
      modal.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      root.classList.add('is-modal-open');
      openModalRoots.add(root);
      syncBodyModalState();
      setBackgroundInert(true);

      window.requestAnimationFrame(() => {
        const close = dialog.querySelector('.gh-performance-modal__close');
        (close || dialog).focus?.();
      });
    };

    const closeModal = ({ restoreFocus = true } = {}) => {
      if (!modal || modal.hidden) return;

      modal.hidden = true;
      openButton?.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-modal-open');
      openModalRoots.delete(root);
      syncBodyModalState();
      setBackgroundInert(false);

      if (restoreFocus) {
        const target = lastFocused?.isConnected ? lastFocused : openButton;
        target?.focus?.();
      }
      lastFocused = null;
    };

    openButton?.addEventListener('click', openModal, { signal });
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeModal(), { signal });
    });

    document.addEventListener(
      'keydown',
      (event) => {
        if (!modal || modal.hidden || !dialog) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = getFocusable(dialog);
        if (!focusable.length) {
          event.preventDefault();
          dialog.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (event.shiftKey && (active === first || !dialog.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      },
      { signal }
    );

    const syncMotionPreference = () => {
      if (reducedMotion.matches) {
        removeLoopClones();
        root.style.setProperty('--gh-loop-distance', '0px');
      } else if (hasApproachedViewport) {
        scheduleLoopRebuild();
      }
    };

    reducedMotion.addEventListener?.('change', syncMotionPreference, { signal });

    document.addEventListener(
      'visibilitychange',
      () => {
        root.classList.toggle('is-page-hidden', document.hidden);
      },
      { signal }
    );
    root.classList.toggle('is-page-hidden', document.hidden);

    viewport?.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'touch') root.classList.add('is-touch-paused');
      },
      { signal }
    );

    ['pointerup', 'pointercancel'].forEach((type) => {
      viewport?.addEventListener(
        type,
        () => root.classList.remove('is-touch-paused'),
        { signal }
      );
    });

    if ('IntersectionObserver' in window) {
      approachObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry?.isIntersecting || hasApproachedViewport) return;
          hasApproachedViewport = true;
          approachObserver?.disconnect();
          approachObserver = null;
          scheduleLoopRebuild();
        },
        { rootMargin: '350px 0px' }
      );
      approachObserver.observe(root);

      visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          root.classList.toggle('is-offscreen', !entry?.isIntersecting);
        },
        { threshold: 0.01 }
      );
      visibilityObserver.observe(root);
    } else {
      hasApproachedViewport = true;
      root.classList.remove('is-offscreen');
      scheduleLoopRebuild();
    }

    if ('ResizeObserver' in window && viewport && sourceGroup) {
      resizeObserver = new ResizeObserver(scheduleLoopRebuild);
      resizeObserver.observe(viewport);
      resizeObserver.observe(sourceGroup);
    } else {
      window.addEventListener('resize', scheduleLoopRebuild, { passive: true, signal });
    }

    const pauseForEditorBlock = (event, paused) => {
      const target = event.target;
      if (target && root.contains(target)) {
        root.classList.toggle('is-editor-paused', paused);
      }
    };

    document.addEventListener('shopify:block:select', (event) => pauseForEditorBlock(event, true), { signal });
    document.addEventListener('shopify:block:deselect', (event) => pauseForEditorBlock(event, false), { signal });

    signal.addEventListener(
      'abort',
      () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeObserver?.disconnect();
        approachObserver?.disconnect();
        visibilityObserver?.disconnect();
        closeModal({ restoreFocus: false });
        removeLoopClones();
        root.classList.remove('is-offscreen', 'is-page-hidden', 'is-editor-paused', 'is-touch-paused');
        root.removeAttribute('data-gh-performance-ready');
      },
      { once: true }
    );

    root.setAttribute('data-gh-performance-ready', 'true');
  };

  const initAll = (scope = document) => collectRoots(scope).forEach(initRoot);

  const destroyWithin = (scope) => {
    collectRoots(scope).forEach((root) => {
      root._ghPerformanceController?.abort?.();
      root._ghPerformanceController = null;
    });
  };

  window[namespace] = { version, initAll, initRoot, destroyWithin };

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Costum-review-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const namespace = window.GHCommunityVideos || {};

  namespace.init = (root) => {
    if (!root || !root.matches('[data-gh-community-videos]')) return;

    if (root._ghCommunityVideosController) {
      root._ghCommunityVideosController.abort();
    }

    const controller = new AbortController();
    const { signal } = controller;
    root._ghCommunityVideosController = controller;

    const designMode = Boolean(window.Shopify?.designMode);
    const slider = root.querySelector('[data-gh-community-videos-slider]');
    const track = root.querySelector('[data-gh-community-videos-track]');
    const sourceGroup = root.querySelector('[data-gh-community-videos-source-group]');
    const stage = root.querySelector('[data-gh-carousel-stage]');
    const carouselToggle = root.querySelector('[data-gh-carousel-toggle]');
    const previousButton = root.querySelector('[data-gh-carousel-previous]');
    const nextButton = root.querySelector('[data-gh-carousel-next]');
    const videos = [...root.querySelectorAll('.gh-review-card__video')];
    const postCount = Number.parseInt(root.dataset.postCount || '0', 10) || 0;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    let hasApproachedViewport = designMode || !('IntersectionObserver' in window);
    let currentGroupCount = 1;
    let loopFrame = 0;
    let resizeObserver = null;
    let activeVideo = null;
    const videoHomes = new Map();
    let manuallyPaused = false;
    let dragState = null;
    let dragFrame = 0;
    let pendingDragPixels = 0;
    let suppressClickUntil = 0;

    root.classList.toggle('is-editor-static', designMode);
    root.classList.toggle('is-page-hidden', document.hidden);


    videos.forEach((video) => {
      const homeShell = video.closest('[data-gh-review-video-shell]');
      const homeButton = homeShell?.querySelector('[data-gh-review-video-toggle]');

      if (!homeShell || !homeButton) return;

      if (!homeButton.dataset.ghVideoId) {
        homeButton.dataset.ghVideoId = video.id;
      }

      videoHomes.set(video, {
        homeShell,
        homeButton,
        mountedShell: homeShell,
        homeFallback: null
      });
    });

    const removeLoopClones = () => {
      if (
        activeVideo &&
        activeVideo.closest('.gh-community-videos__group--duplicate')
      ) {
        pauseVideo(activeVideo);
      }

      track?.querySelectorAll('.gh-community-videos__group--duplicate').forEach((group) => {
        group.remove();
      });
      currentGroupCount = 1;
    };

    const createPosterFallback = (shell) => {
      const posterSrc = shell.dataset.posterSrc || shell.querySelector('video')?.poster || '';

      if (posterSrc) {
        const image = document.createElement('img');
        image.className = 'gh-review-card__image';
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.src = posterSrc;
        if (shell.dataset.posterSrcset) image.srcset = shell.dataset.posterSrcset;
        if (shell.dataset.posterSizes) image.sizes = shell.dataset.posterSizes;
        return image;
      }

      const placeholder = document.createElement('div');
      placeholder.className = 'gh-review-card__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.textContent = shell.dataset.posterFallback || 'GH';
      placeholder.append(label);
      return placeholder;
    };

    const createDuplicateGroup = () => {
      if (!sourceGroup) return null;

      const clone = sourceGroup.cloneNode(true);
      clone.removeAttribute('data-gh-community-videos-source-group');
      clone.classList.add('gh-community-videos__group--duplicate');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });

      clone.querySelectorAll('.is-video-playing').forEach((element) => {
        element.classList.remove('is-video-playing');
      });

      clone.querySelectorAll('[data-gh-review-video-shell]').forEach((shell) => {
        const video = shell.querySelector('.gh-review-card__video');
        const button = shell.querySelector('[data-gh-review-video-toggle]');
        const videoId =
          button?.dataset.ghVideoId ||
          button?.getAttribute('aria-controls') ||
          video?.id ||
          '';

        const fallback = createPosterFallback(shell);
        fallback.classList.add('gh-review-card__proxy-poster');
        fallback.setAttribute('data-gh-video-proxy-poster', '');

        if (video) {
          video.replaceWith(fallback);
        } else {
          shell.prepend(fallback);
        }

        if (button) {
          if (videoId) button.dataset.ghVideoId = videoId;
          button.dataset.ghVideoProxy = 'true';
          button.removeAttribute('aria-controls');
          button.setAttribute('aria-pressed', 'false');
          button.tabIndex = -1;
        }
      });

      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('[aria-controls]').forEach((element) => {
        element.removeAttribute('aria-controls');
      });

      clone.querySelectorAll('video').forEach((element) => {
        element.remove();
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
        image.fetchPriority = 'auto';
        image.alt = '';
      });

      clone.querySelectorAll('a, button, input, select, textarea, summary, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      return clone;
    };

    const autoplayIsActive = () => {
      return !designMode && !reducedMotionQuery.matches && postCount > 1;
    };

    const updateCarouselToggle = () => {
      if (!carouselToggle) return;

      const canAutoplay = autoplayIsActive();
      carouselToggle.disabled = !canAutoplay;
      carouselToggle.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');

      const nextLabel = manuallyPaused
        ? carouselToggle.dataset.playLabel || 'Resume carousel'
        : carouselToggle.dataset.pauseLabel || 'Pause carousel';

      carouselToggle.setAttribute('aria-label', nextLabel);
      carouselToggle.title = nextLabel;
      root.classList.toggle('is-carousel-manually-paused', manuallyPaused);
    };

    const setManualPause = (paused) => {
      manuallyPaused = Boolean(paused);
      updateCarouselToggle();
    };

    const getTrackAnimation = () => {
      if (!track || !root.classList.contains('is-loop-ready')) return null;
      return track.getAnimations().find((animation) => {
        return !animation.animationName || animation.animationName === 'ghCommunityVideoScroll';
      }) || track.getAnimations()[0] || null;
    };

    const getCarouselMetrics = () => {
      if (!slider || !sourceGroup) return null;

      const firstItem = sourceGroup.querySelector('.gh-community-videos__item');
      const styles = window.getComputedStyle(sourceGroup);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = (firstItem?.getBoundingClientRect().width || slider.clientWidth) + gap;
      const groupWidth = sourceGroup.getBoundingClientRect().width;

      if (step <= 0 || groupWidth <= 0) return null;
      return { step, groupWidth };
    };

    const shiftLoopByPixels = (pixels) => {
      const animation = getTrackAnimation();
      const metrics = getCarouselMetrics();
      if (!animation || !metrics) return false;

      const timing = animation.effect?.getTiming?.();
      const duration = Number(timing?.duration);
      if (!Number.isFinite(duration) || duration <= 0) return false;

      const reverseFactor = root.classList.contains('gh-community-videos--reverse')
        ? -1
        : 1;
      const currentTime = Number(animation.currentTime || 0);
      const deltaTime = reverseFactor * (pixels / metrics.groupWidth) * duration;
      const nextTime = ((currentTime + deltaTime) % duration + duration) % duration;
      animation.currentTime = nextTime;
      return true;
    };

    const nudgeCarousel = (direction) => {
      if (!slider || !sourceGroup) return;
      if (activeVideo) pauseVideo(activeVideo);

      const metrics = getCarouselMetrics();
      const step = metrics?.step || slider.clientWidth;
      const movedAnimation = shiftLoopByPixels(direction * step);

      if (!movedAnimation) {
        slider.scrollBy({
          left: direction * step,
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
        });
      }
    };

    const requiredGroupCount = () => {
      if (!slider || !sourceGroup) return 1;
      const groupWidth = sourceGroup.getBoundingClientRect().width;
      const viewportWidth = slider.clientWidth;
      if (groupWidth <= 0 || viewportWidth <= 0) return 2;
      return Math.min(6, Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1));
    };

    const syncLoop = () => {
      loopFrame = 0;
      if (!slider || !track || !sourceGroup) return;

      const shouldLoop = hasApproachedViewport && autoplayIsActive();
      if (!shouldLoop) {
        root.classList.remove('is-loop-ready');
        root.style.removeProperty('--gh-community-loop-shift');
        if (currentGroupCount > 1) removeLoopClones();
        slider.tabIndex = 0;
        updateCarouselToggle();
        return;
      }

      const neededGroups = requiredGroupCount();
      if (neededGroups !== currentGroupCount) {
        root.classList.remove('is-loop-ready');
        removeLoopClones();

        for (let index = 1; index < neededGroups; index += 1) {
          const clone = createDuplicateGroup();
          if (clone) track.append(clone);
        }

        currentGroupCount = neededGroups;
      }

      root.style.setProperty(
        '--gh-community-loop-shift',
        `-${100 / currentGroupCount}%`
      );
      slider.scrollLeft = 0;
      slider.tabIndex = -1;
      root.classList.add('is-loop-ready');
      updateCarouselToggle();
    };

    const scheduleLoopSync = () => {
      if (loopFrame) return;
      loopFrame = window.requestAnimationFrame(syncLoop);
    };

    updateCarouselToggle();

    const setButtonState = (button, playing) => {
      if (!button) return;

      button.setAttribute('aria-pressed', playing ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        playing
          ? button.dataset.pauseLabel || 'Pause video'
          : button.dataset.playLabel || 'Play video'
      );

      button
        .closest('.gh-review-card')
        ?.classList.toggle('is-video-playing', playing);
    };

    const setVideoState = (video, playing) => {
      if (!video) return;

      const currentShell = video.closest('[data-gh-review-video-shell]');
      const videoId = video.id;

      root.querySelectorAll('[data-gh-review-video-toggle]').forEach((button) => {
        if (button.dataset.ghVideoId !== videoId) return;
        setButtonState(button, playing && button.closest('[data-gh-review-video-shell]') === currentShell);
      });
    };

    const createHomeFallback = (video) => {
      const record = videoHomes.get(video);
      if (!record || record.homeFallback) return record?.homeFallback || null;

      const fallback = createPosterFallback(record.homeShell);
      fallback.classList.add('gh-review-card__home-fallback');
      fallback.setAttribute('data-gh-video-home-fallback', '');

      record.homeShell.insertBefore(fallback, record.homeButton);
      record.homeFallback = fallback;
      return fallback;
    };

    const mountVideoInShell = (video, targetShell) => {
      const record = videoHomes.get(video);
      if (!record || !targetShell) return false;

      const currentShell = video.closest('[data-gh-review-video-shell]');
      if (currentShell === targetShell) {
        record.mountedShell = targetShell;
        return true;
      }

      if (currentShell === record.homeShell) {
        createHomeFallback(video)?.removeAttribute('hidden');
      } else {
        currentShell
          ?.querySelector('[data-gh-video-proxy-poster]')
          ?.removeAttribute('hidden');
      }

      targetShell
        .querySelector('[data-gh-video-proxy-poster]')
        ?.setAttribute('hidden', '');

      if (targetShell === record.homeShell && record.homeFallback) {
        record.homeFallback.setAttribute('hidden', '');
      }

      const targetButton = targetShell.querySelector('[data-gh-review-video-toggle]');
      targetShell.insertBefore(video, targetButton || null);
      record.mountedShell = targetShell;
      return true;
    };

    const restoreVideoHome = (video) => {
      const record = videoHomes.get(video);
      if (!record) return;

      const currentShell = video.closest('[data-gh-review-video-shell]');

      if (currentShell && currentShell !== record.homeShell) {
        currentShell
          .querySelector('[data-gh-video-proxy-poster]')
          ?.removeAttribute('hidden');

        record.homeShell.insertBefore(video, record.homeButton);
      }

      if (record.homeFallback) {
        record.homeFallback.remove();
        record.homeFallback = null;
      }

      record.mountedShell = record.homeShell;
    };

    const syncSectionPlaybackState = () => {
      const hasPlayingVideo = videos.some(
        (video) => !video.paused && !video.ended
      );
      root.classList.toggle('has-playing-video', hasPlayingVideo);
    };

    const pauseVideo = (video) => {
      if (!video) return;

      if (!video.paused) video.pause();
      setVideoState(video, false);
      restoreVideoHome(video);

      if (activeVideo === video) activeVideo = null;
      syncSectionPlaybackState();
    };

    const pauseOtherVideos = (currentVideo) => {
      videos.forEach((video) => {
        if (video !== currentVideo) pauseVideo(video);
      });
    };

    const playVideo = async (video, targetShell) => {
      if (!video || !video.isConnected || !targetShell) return;

      pauseOtherVideos(video);

      if (!mountVideoInShell(video, targetShell)) return;

      video.autoplay = false;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.playsInline = true;
      video.preload = 'metadata';
      video.disablePictureInPicture = true;
      video.removeAttribute('autoplay');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute(
        'controlslist',
        'nodownload noplaybackrate noremoteplayback'
      );
      video.tabIndex = -1;

      try {
        await video.play();
        activeVideo = video;
        setVideoState(video, true);
        syncSectionPlaybackState();
      } catch (error) {
        pauseVideo(video);
      }
    };

    const toggleVideo = (video, targetShell) => {
      if (!video || !targetShell) return;

      const currentShell = video.closest('[data-gh-review-video-shell]');
      const isPlaying = !video.paused && !video.ended;

      if (isPlaying && currentShell === targetShell) {
        pauseVideo(video);
      } else {
        void playVideo(video, targetShell);
      }
    };

    videos.forEach((video) => {
      video.autoplay = false;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.preload = 'metadata';
      video.removeAttribute('autoplay');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      setVideoState(video, false);

      video.addEventListener(
        'play',
        () => {
          pauseOtherVideos(video);
          activeVideo = video;
          setVideoState(video, true);
          syncSectionPlaybackState();
        },
        { signal }
      );

      video.addEventListener(
        'pause',
        () => {
          setVideoState(video, false);
          restoreVideoHome(video);
          if (activeVideo === video) activeVideo = null;
          syncSectionPlaybackState();
        },
        { signal }
      );

      video.addEventListener(
        'ended',
        () => {
          video.currentTime = 0;
          pauseVideo(video);
        },
        { signal }
      );
    });

    root.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-gh-review-video-toggle]');
        if (!button || !root.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const shell = button.closest('[data-gh-review-video-shell]');
        const videoId =
          button.dataset.ghVideoId ||
          button.getAttribute('aria-controls') ||
          '';
        const video = videoId ? document.getElementById(videoId) : null;

        if (!video || !root.contains(video) || !shell) return;
        toggleVideo(video, shell);
      },
      { signal }
    );

    carouselToggle?.addEventListener(
      'click',
      () => {
        setManualPause(!manuallyPaused);
      },
      { signal }
    );

    previousButton?.addEventListener(
      'click',
      () => nudgeCarousel(-1),
      { signal }
    );

    nextButton?.addEventListener(
      'click',
      () => nudgeCarousel(1),
      { signal }
    );

    stage?.addEventListener(
      'pointerenter',
      (event) => {
        if (event.pointerType === 'mouse') {
          root.classList.add('is-carousel-hover-paused');
        }
      },
      { signal }
    );

    stage?.addEventListener(
      'pointerleave',
      (event) => {
        if (event.pointerType === 'mouse') {
          root.classList.remove('is-carousel-hover-paused');
        }
      },
      { signal }
    );

    stage?.addEventListener(
      'focusin',
      () => {
        root.classList.add('is-carousel-focus-paused');
      },
      { signal }
    );

    stage?.addEventListener(
      'focusout',
      (event) => {
        if (!stage.contains(event.relatedTarget)) {
          root.classList.remove('is-carousel-focus-paused');
        }
      },
      { signal }
    );

    const endCarouselDrag = (event) => {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;

      if (slider?.hasPointerCapture?.(dragState.pointerId)) {
        slider.releasePointerCapture(dragState.pointerId);
      }

      if (dragState.moved) {
        suppressClickUntil = performance.now() + 350;
      }

      dragState = null;
      pendingDragPixels = 0;
      root.classList.remove('is-carousel-dragging');
    };

    slider?.addEventListener(
      'pointerdown',
      (event) => {
        if (!root.classList.contains('is-loop-ready')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, select, textarea, summary')) return;

        if (activeVideo) pauseVideo(activeVideo);

        dragState = {
          pointerId: event.pointerId,
          lastX: event.clientX,
          totalX: 0,
          moved: false
        };

        slider.setPointerCapture?.(event.pointerId);
        root.classList.add('is-carousel-dragging');
      },
      { signal }
    );

    slider?.addEventListener(
      'pointermove',
      (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        const deltaX = event.clientX - dragState.lastX;
        dragState.lastX = event.clientX;
        dragState.totalX += deltaX;

        if (Math.abs(dragState.totalX) > 5) {
          dragState.moved = true;
        }

        pendingDragPixels += -deltaX;

        if (!dragFrame) {
          dragFrame = window.requestAnimationFrame(() => {
            dragFrame = 0;
            const pixels = pendingDragPixels;
            pendingDragPixels = 0;
            shiftLoopByPixels(pixels);
          });
        }

        if (dragState.moved) event.preventDefault();
      },
      { passive: false, signal }
    );

    slider?.addEventListener('pointerup', endCarouselDrag, { signal });
    slider?.addEventListener('pointercancel', endCarouselDrag, { signal });
    slider?.addEventListener('lostpointercapture', endCarouselDrag, { signal });

    slider?.addEventListener(
      'click',
      (event) => {
        if (performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      { capture: true, signal }
    );

    if ('IntersectionObserver' in window && !designMode) {
      root.classList.add('is-offscreen');
      const sectionObserver = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          root.classList.toggle('is-offscreen', !visible);

          if (visible) {
            hasApproachedViewport = true;
            scheduleLoopSync();
          } else if (activeVideo) {
            pauseVideo(activeVideo);
          }
        },
        { rootMargin: '600px 0px', threshold: 0 }
      );

      sectionObserver.observe(root);
      signal.addEventListener(
        'abort',
        () => sectionObserver.disconnect(),
        { once: true }
      );
    } else {
      root.classList.remove('is-offscreen');
      scheduleLoopSync();
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        root.classList.toggle('is-page-hidden', document.hidden);
        if (document.hidden && activeVideo) pauseVideo(activeVideo);
      },
      { signal }
    );

    slider?.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        nudgeCarousel(event.key === 'ArrowRight' ? 1 : -1);
      },
      { signal }
    );

    const onMediaChange = () => {
      scheduleLoopSync();
      updateCarouselToggle();
    };
    mobileQuery.addEventListener?.('change', onMediaChange);
    reducedMotionQuery.addEventListener?.('change', onMediaChange);
    signal.addEventListener(
      'abort',
      () => {
        mobileQuery.removeEventListener?.('change', onMediaChange);
        reducedMotionQuery.removeEventListener?.('change', onMediaChange);
      },
      { once: true }
    );

    if ('ResizeObserver' in window && slider && sourceGroup) {
      resizeObserver = new ResizeObserver(scheduleLoopSync);
      resizeObserver.observe(slider);
      resizeObserver.observe(sourceGroup);
      signal.addEventListener('abort', () => resizeObserver?.disconnect(), { once: true });
    } else {
      window.addEventListener('resize', scheduleLoopSync, { passive: true, signal });
    }

    if (designMode) {
      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const item = event.target?.closest?.('.gh-community-videos__item');
          if (!item || !root.contains(item)) return;
          item.scrollIntoView({
            behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        },
        { signal }
      );
    }

    signal.addEventListener(
      'abort',
      () => {
        if (loopFrame) window.cancelAnimationFrame(loopFrame);
        if (dragFrame) window.cancelAnimationFrame(dragFrame);
        videos.forEach((video) => pauseVideo(video));
        removeLoopClones();
        if (root._ghCommunityVideosController === controller) {
          delete root._ghCommunityVideosController;
        }
      },
      { once: true }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (String(event.detail?.sectionId || '') === root.id.replace('GHCommunityVideos-', '')) {
          controller.abort();
        }
      },
      { signal }
    );
  };

  if (!namespace.editorBound) {
    document.addEventListener('shopify:section:load', (event) => {
      const candidates = [];
      if (event.target?.matches?.('[data-gh-community-videos]')) candidates.push(event.target);
      event.target?.querySelectorAll?.('[data-gh-community-videos]').forEach((item) => candidates.push(item));
      candidates.forEach((item) => namespace.init(item));
    });
    namespace.editorBound = true;
  }

  window.GHCommunityVideos = namespace;
  document.querySelectorAll('[data-gh-community-videos]').forEach((item) => namespace.init(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Gymhawk-music"] && !Shopify.designMode) return;
  try {
    
(() => {
  const RUNTIME_KEY = '__GYMHAWK_MUSIC_VIDEOS_V2__';
  if (window[RUNTIME_KEY]) {
    window[RUNTIME_KEY].scan();
    return;
  }

  const instances = new WeakMap();

  const initSection = (section) => {
    if (!section || section.dataset.ghMusicReady === 'true') return;
    section.dataset.ghMusicReady = 'true';

    const controller = new AbortController();
    const signal = controller.signal;

    const mobileQuery = window.matchMedia('(max-width: 699px)');
    const cards = Array.from(section.querySelectorAll('[data-gh-card]'));
    const toast = section.querySelector('[data-gh-toast]');
    const requestControllers = new Set();
    const timers = new Set();
    let activeCard = null;
    let toastTimer = null;
    let releaseObserver = null;
    let revealObserver = null;
    let legacyMediaListener = false;

    const schedule = (callback, delay) => {
      const timer = window.setTimeout(() => {
        timers.delete(timer);
        callback();
      }, delay);
      timers.add(timer);
      return timer;
    };

    const fetchWithTimeout = async (url, options = {}, timeout = 12000) => {
      const requestController = new AbortController();
      requestControllers.add(requestController);
      let timedOut = false;
      const abortRequest = () => requestController.abort();
      signal.addEventListener('abort', abortRequest, { once: true });
      const timer = window.setTimeout(() => {
        timedOut = true;
        requestController.abort();
      }, timeout);

      try {
        return await fetch(url, { ...options, signal: requestController.signal });
      } catch (error) {
        if (timedOut) throw new Error('Netzwerk-Zeitüberschreitung. Bitte erneut versuchen.');
        throw error;
      } finally {
        window.clearTimeout(timer);
        signal.removeEventListener('abort', abortRequest);
        requestControllers.delete(requestController);
      }
    };

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = schedule(() => toast.classList.remove('is-visible'), 2200);
    };

    const getCardAnalytics = (card) => ({
      video_title: card?.dataset.shareTitle || '',
      video_position: Number(card?.dataset.videoPosition || 0),
      video_type: card?.dataset.videoType || '',
      offer_type: card?.dataset.offerType || '',
      offer_title: card?.dataset.offerTitle || '',
      offer_handle: card?.dataset.offerHandle || '',
      offer_url: card?.dataset.offerUrl || '',
      spotify_url: card?.dataset.spotifyUrl || ''
    });

    const trackEvent = (name, detail = {}) => {
      const payload = { event: name, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(name, { detail }));
      document.dispatchEvent(new CustomEvent('gh:analytics', { detail: payload }));
    };

    const stopCard = (card) => {
      if (!card) return;
      const player = card.querySelector('[data-gh-player]');

      player?.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {
          // Clearing the player below also stops playback.
        }
      });

      if (player) player.innerHTML = '';
      card.classList.remove('is-playing');
      if (activeCard === card) activeCard = null;
    };

    const stopOtherCards = (nextCard) => {
      cards.forEach((card) => {
        if (card !== nextCard && card.classList.contains('is-playing')) stopCard(card);
      });
    };

    const buildExternalPlayer = (card, player) => {
      const type = card.dataset.videoType;
      const id = card.dataset.videoId;
      const isMobile = mobileQuery.matches;
      if (!type || !id) return null;

      const iframe = document.createElement('iframe');
      iframe.title = card.dataset.shareTitle || 'Music video';
      iframe.loading = 'eager';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';

      const permissions = [
        'accelerometer',
        'autoplay',
        'clipboard-write',
        'encrypted-media',
        'gyroscope',
        'web-share'
      ];

      if (isMobile) permissions.push('picture-in-picture', 'fullscreen');
      iframe.allow = permissions.join('; ');

      if (isMobile) {
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('webkitallowfullscreen', '');
      }

      if (type === 'youtube') {
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1&playsinline=1&fs=${isMobile ? '1' : '0'}`;
      } else if (type === 'vimeo') {
        iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&title=0&byline=0&portrait=0&pip=${isMobile ? '1' : '0'}`;
      } else {
        return null;
      }

      player.appendChild(iframe);
      return iframe;
    };

    const buildShopifyPlayer = (card, player) => {
      const template = card.querySelector('[data-gh-shopify-template]');
      if (!template) return null;

      player.appendChild(template.content.cloneNode(true));
      const video = player.querySelector('video');
      if (!video) return null;

      video.playsInline = true;
      video.setAttribute('playsinline', '');

      if (mobileQuery.matches) {
        video.controls = true;
        video.removeAttribute('controlsList');
      } else {
        video.controls = false;
        video.removeAttribute('controls');
        video.setAttribute('controlsList', 'nofullscreen nodownload noremoteplayback');
        video.disablePictureInPicture = true;

        const controls = document.createElement('div');
        controls.className = 'gh-video-custom-controls';
        controls.innerHTML = `
          <button type="button" data-custom-play aria-label="Wiedergabe pausieren">
            <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path data-play-shape d="M8 5v14M16 5v14"></path></svg>
          </button>
          <input type="range" min="0" max="100" value="0" step="0.1" aria-label="Videoposition" data-custom-progress>
          <span class="gh-video-custom-controls__time" data-custom-time>00:00 / 00:00</span>
          <button type="button" data-custom-mute aria-label="Ton ausschalten">
            <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path fill="none" d="M5 9v6h4l5 4V5L9 9H5Zm12 1.5c.7.8.7 2.2 0 3"></path></svg>
          </button>`;
        player.appendChild(controls);

        const playButton = controls.querySelector('[data-custom-play]');
        const playShape = controls.querySelector('[data-play-shape]');
        const progress = controls.querySelector('[data-custom-progress]');
        const time = controls.querySelector('[data-custom-time]');
        const muteButton = controls.querySelector('[data-custom-mute]');

        const formatTime = (seconds) => {
          if (!Number.isFinite(seconds)) return '00:00';
          const minutes = Math.floor(seconds / 60);
          const remaining = Math.floor(seconds % 60);
          return `${String(minutes).padStart(2, '0')}:${String(remaining).padStart(2, '0')}`;
        };

        const syncControls = () => {
          const duration = Number.isFinite(video.duration) ? video.duration : 0;
          const current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
          progress.value = duration > 0 ? String((current / duration) * 100) : '0';
          time.textContent = `${formatTime(current)} / ${formatTime(duration)}`;
          playShape.setAttribute('d', video.paused ? 'M8 5v14l11-7Z' : 'M8 5v14M16 5v14');
          playButton.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Wiedergabe pausieren');
          muteButton.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton ausschalten');
        };

        playButton.addEventListener('click', () => {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });

        video.addEventListener('click', () => {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });

        progress.addEventListener('input', () => {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          video.currentTime = (Number(progress.value) / 100) * video.duration;
        });

        muteButton.addEventListener('click', () => {
          video.muted = !video.muted;
          syncControls();
        });

        video.addEventListener('loadedmetadata', syncControls);
        video.addEventListener('timeupdate', syncControls);
        video.addEventListener('play', syncControls);
        video.addEventListener('pause', syncControls);
        video.addEventListener('volumechange', syncControls);
        syncControls();
      }

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // Native controls remain available if autoplay is blocked.
        });
      }

      return video;
    };

    const playCard = (card) => {
      if (!card || card.classList.contains('is-playing')) return;
      const player = card.querySelector('[data-gh-player]');
      if (!player) return;

      stopOtherCards(card);
      player.innerHTML = '';

      let media = null;
      if (card.dataset.videoType === 'shopify') {
        media = buildShopifyPlayer(card, player);
      } else {
        media = buildExternalPlayer(card, player);
      }

      if (!media) return;
      card.classList.add('is-playing');
      activeCard = card;
      trackEvent('gh_video_play', getCardAnalytics(card));
    };

    const enterMobileFullscreen = async (card) => {
      if (!mobileQuery.matches) return;
      if (!card.classList.contains('is-playing')) playCard(card);

      const shell = card.querySelector('[data-gh-player-shell]');
      const video = card.querySelector('[data-gh-player] video');
      if (!shell) return;

      try {
        if (shell.requestFullscreen) {
          await shell.requestFullscreen();
          return;
        }
        if (shell.webkitRequestFullscreen) {
          shell.webkitRequestFullscreen();
          return;
        }
        if (video?.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
          return;
        }
        showToast('Vollbild im Player öffnen');
      } catch (error) {
        showToast('Vollbild im Player öffnen');
      }
    };

    const copyText = async (text) => {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    };

    const shareCard = async (card) => {
      const url = card.dataset.shareUrl || window.location.href;
      const title = card.dataset.shareTitle || document.title;
      trackEvent('gh_video_share', { ...getCardAnalytics(card), share_url: url });

      try {
        if (navigator.share) {
          await navigator.share({ title, text: `${title} · GYMHAWK`, url });
          return;
        }
        await copyText(url);
        showToast('Link kopiert');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        try {
          await copyText(url);
          showToast('Link kopiert');
        } catch (copyError) {
          showToast('Link konnte nicht kopiert werden');
        }
      }
    };

    section.addEventListener('change', (event) => {
      const select = event.target.closest('[data-gh-variant-select]');
      if (!select || !section.contains(select)) return;

      const releaseCard = select.closest('[data-gh-release-card]');
      const price = releaseCard?.querySelector('[data-gh-product-price]');
      const option = select.selectedOptions?.[0];
      if (!price || !option) return;

      const mainPrice = price.querySelector('strong');
      const comparePrice = price.querySelector('s');
      const fromLabel = price.querySelector('.gh-release-card__from');
      if (mainPrice && option.dataset.price) mainPrice.textContent = option.dataset.price;
      if (fromLabel) fromLabel.hidden = true;

      if (option.dataset.comparePrice) {
        if (comparePrice) comparePrice.textContent = option.dataset.comparePrice;
        else price.insertAdjacentHTML('beforeend', `<s>${option.dataset.comparePrice}</s>`);
      } else if (comparePrice) {
        comparePrice.remove();
      }

      const form = select.closest('.gh-release-card__form');
      form?.querySelectorAll('[data-gh-purchase]').forEach((button) => {
        button.disabled = option.dataset.available !== 'true';
      });
    }, { signal });

    const getCartSurface = () =>
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-drawer');

    const getCartSectionIds = (cartSurface) => {
      if (typeof cartSurface?.getSectionsToRender === 'function') {
        return cartSurface.getSectionsToRender().map((sectionItem) => sectionItem.id).filter(Boolean);
      }

      const ids = new Set();
      [
        cartSurface,
        document.querySelector('#cart-icon-bubble'),
        document.querySelector('[data-cart-count]')
      ].forEach((element) => {
        const wrapper = element?.closest?.('[id^="shopify-section-"]');
        if (wrapper?.id) ids.add(wrapper.id.replace('shopify-section-', ''));
      });
      return Array.from(ids);
    };

    const openCartSurface = (cartSurface) => {
      if (!cartSurface) return false;
      if (typeof cartSurface.open === 'function') {
        cartSurface.open();
        return true;
      }

      const details = cartSurface.querySelector?.('details');
      if (details) details.open = true;
      cartSurface.classList?.add('active', 'is-open', 'animate');
      document.body.classList.add('overflow-hidden');
      document.dispatchEvent(new CustomEvent('cart:open', { detail: { source: 'gh-music' } }));
      return true;
    };

    const replaceReturnedSections = (sections) => {
      if (!sections || typeof sections !== 'object') return false;
      let replaced = false;

      Object.entries(sections).forEach(([sectionId, html]) => {
        if (!html) return;
        const current = document.getElementById(`shopify-section-${sectionId}`);
        if (!current) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.getElementById(`shopify-section-${sectionId}`) || parsed.body.firstElementChild;
        if (!replacement) return;

        current.replaceWith(replacement);
        replaced = true;
      });

      return replaced;
    };

    const refreshCartIndicators = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetchWithTimeout(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const cart = await response.json();
        const countTargets = document.querySelectorAll(
          '[data-cart-count], .cart-count-bubble span:first-child, #cart-icon-bubble .cart-count-bubble span:first-child'
        );
        countTargets.forEach((target) => { target.textContent = String(cart.item_count); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'gh-music' } }));
        return cart;
      } catch (error) {
        return null;
      }
    };

    const renderCartResponse = async (parsedState, cartSurface) => {
      if (typeof cartSurface?.renderContents === 'function' && parsedState?.sections) {
        cartSurface.renderContents(parsedState);
        schedule(() => openCartSurface(cartSurface), 60);
        return;
      }

      const replaced = replaceReturnedSections(parsedState?.sections);
      const updatedSurface = getCartSurface();
      if (replaced) {
        schedule(() => openCartSurface(updatedSurface), 60);
        return;
      }

      await refreshCartIndicators();
      openCartSurface(updatedSurface);
    };

    section.addEventListener('submit', async (event) => {
      const form = event.target.closest('.gh-release-card__form');
      if (!form || !section.contains(form)) return;

      const submitter = event.submitter;
      const purchaseAction = submitter?.dataset.ghPurchase;
      if (!purchaseAction) return;

      event.preventDefault();
      const buttons = Array.from(form.querySelectorAll('[data-gh-purchase]'));
      buttons.forEach((button) => {
        button.disabled = true;
        button.classList.add('is-loading');
      });

      try {
        const root = window.Shopify?.routes?.root || '/';
        const card = form.closest('[data-gh-card]');
        const variantSelect = form.querySelector('[name="id"]');
        const cartSurface = getCartSurface();
        const sectionIds = getCartSectionIds(cartSurface);
        const formData = new FormData(form);

        if (sectionIds.length) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        const response = await fetchWithTimeout(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        }, 12000);

        const parsedState = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(parsedState.description || parsedState.message || 'Produkt konnte nicht hinzugefügt werden');
        }

        const eventDetail = {
          ...getCardAnalytics(card),
          variant_id: variantSelect?.value || '',
          quantity: Number(formData.get('quantity') || 1),
          value: parsedState.final_price ? parsedState.final_price / 100 : undefined,
          currency: window.Shopify?.currency?.active || ''
        };

        if (purchaseAction === 'buy') {
          trackEvent('gh_single_buy_now', eventDetail);
          window.location.assign(`${root}checkout`);
          return;
        }

        trackEvent('gh_single_add_to_cart', eventDetail);
        await renderCartResponse(parsedState, cartSurface);
        showToast('Zum Warenkorb hinzugefügt');
      } catch (error) {
        if (!signal.aborted) showToast(error?.message || 'Bitte erneut versuchen');
      } finally {
        const variantField = form.querySelector('[name="id"]');
        const selectedOption = variantField?.selectedOptions?.[0];
        const isAvailable = selectedOption
          ? selectedOption.dataset.available === 'true'
          : variantField?.dataset.available === 'true';

        buttons.forEach((button) => {
          button.disabled = !isAvailable;
          button.classList.remove('is-loading');
        });
      }
    }, { signal });

    section.addEventListener('click', (event) => {
      const card = event.target.closest('[data-gh-card]');
      if (!card || !section.contains(card)) return;

      if (event.target.closest('.gh-video-card__youtube')) {
        trackEvent('gh_youtube_open', getCardAnalytics(card));
        return;
      }

      if (event.target.closest('.gh-video-card__spotify')) {
        trackEvent('gh_spotify_open', getCardAnalytics(card));
        return;
      }

      if (event.target.closest('[data-gh-single-link]')) {
        trackEvent('gh_single_view', { ...getCardAnalytics(card), interaction: 'product_details' });
        return;
      }

      if (event.target.closest('[data-gh-collection-link]')) {
        trackEvent('gh_collection_open', getCardAnalytics(card));
        return;
      }

      if (event.target.closest('[data-gh-play]')) {
        playCard(card);
        return;
      }

      if (event.target.closest('[data-gh-stop]')) {
        stopCard(card);
        return;
      }

      if (event.target.closest('[data-gh-fullscreen]')) {
        enterMobileFullscreen(card);
        return;
      }

      if (event.target.closest('[data-gh-share]')) {
        shareCard(card);
      }
    }, { signal });

    const handleViewportChange = () => {
      // Rebuild on the next click so desktop never retains mobile fullscreen permission.
      if (activeCard) stopCard(activeCard);
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleViewportChange, { signal });
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleViewportChange);
      legacyMediaListener = true;
    }

    const releaseCards = section.querySelectorAll('[data-gh-release-card]');
    if ('IntersectionObserver' in window && releaseCards.length) {
      releaseObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target.closest('[data-gh-card]');
          if (card?.dataset.offerType === 'product') {
            trackEvent('gh_single_view', { ...getCardAnalytics(card), interaction: 'impression' });
          }
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.55 });

      releaseCards.forEach((releaseCard) => releaseObserver.observe(releaseCard));
    }

    const revealItems = section.querySelectorAll('.gh-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealObserver = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          currentObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '40px 0px' });

      revealItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const initiallyVisible = rect.bottom >= 0 && rect.top <= window.innerHeight * 1.05;
        if (initiallyVisible) return;
        item.classList.add('is-pending');
        revealObserver.observe(item);
      });
    }

    const destroy = () => {
      if (signal.aborted) return;
      controller.abort();
      requestControllers.forEach((requestController) => requestController.abort());
      requestControllers.clear();
      timers.forEach((timer) => window.clearTimeout(timer));
      timers.clear();
      if (legacyMediaListener && typeof mobileQuery.removeListener === 'function') {
        mobileQuery.removeListener(handleViewportChange);
      }
      releaseObserver?.disconnect();
      revealObserver?.disconnect();
      cards.forEach(stopCard);
      section.querySelectorAll('.gh-reveal.is-pending').forEach((item) => item.classList.remove('is-pending'));
      delete section.dataset.ghMusicReady;
      instances.delete(section);
    };

    instances.set(section, { destroy });
  };

  const destroyFromContainer = (container) => {
    const root = container?.matches?.('[data-gh-music-section]')
      ? container
      : container?.querySelector?.('[data-gh-music-section]');
    instances.get(root)?.destroy();
  };

  const scan = (scope = document) => {
    if (scope?.matches?.('[data-gh-music-section]')) initSection(scope);
    scope?.querySelectorAll?.('[data-gh-music-section]').forEach(initSection);
  };

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyFromContainer(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  window[RUNTIME_KEY] = { scan };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){"use strict";var runtimeKey="__ghMegaHeaderRuntimeV3";var runtimeVersion="3.2.0";var existingRuntime=window[runtimeKey];if(existingRuntime&&existingRuntime.version===runtimeVersion){existingRuntime.initAll(document);return;}if(existingRuntime&&existingRuntime.instances instanceof Map){Array.from(existingRuntime.instances.values()).forEach(function(instance){if(instance&&typeof instance.destroy==="function"){instance.destroy();}});}var instances=new Map();function collectHeaders(scope){if(!scope)return[];var headers=[];if(
scope.matches&&
scope.matches(".gh-mega-header[data-gh-section-id]")
){headers.push(scope);}if(scope.querySelectorAll){scope
.querySelectorAll(".gh-mega-header[data-gh-section-id]")
.forEach(function(header){headers.push(header);});}return headers;}function initialise(header){if(!header||!header.isConnected)return;var instanceKey=String(header.dataset.ghSectionId||"");if(!instanceKey)return;var previousInstance=instances.get(instanceKey);if(previousInstance&&typeof previousInstance.destroy==="function"){previousInstance.destroy();}var sectionRoot=header.closest(".shopify-section")||header.parentElement;var cartDrawer=sectionRoot
? sectionRoot.querySelector("[data-gh-cart-drawer-root]")
:null;var mobileNav=header.querySelector(".gh-mega-header__nav");var mobileToggle=header.querySelector(".gh-mega-header__mobile-toggle");var mobileBackdrop=
(sectionRoot&&sectionRoot.querySelector("[data-gh-mobile-menu-backdrop]"))||
header.nextElementSibling;var megaItems=Array.from(header.querySelectorAll(".gh-mega-header__nav-item--mega"));var megaTriggers=Array.from(header.querySelectorAll(".gh-mega-header__mega-trigger"));var mobileCloseButtons=Array.from(header.querySelectorAll("[data-gh-mobile-menu-close]"));var cartOpenButtons=Array.from(header.querySelectorAll("[data-gh-cart-drawer-open], [data-gh-mobile-cart-open]"));var countBubble=header.querySelector("[data-gh-cart-count-bubble]");var statusText=header.querySelector("[data-gh-cart-status]");var mobileCartCount=header.querySelector("[data-gh-mobile-cart-count]");var configElement=header.querySelector("[data-gh-header-config]");var headerConfig={};try{headerConfig=configElement ? JSON.parse(configElement.textContent||"{}"):{};}catch(error){headerConfig={};}var strings=headerConfig.strings||{};var showLineItemProperties=headerConfig.showLineItemProperties===true;var trackingEnabled=headerConfig.trackingEnabled!==false;var cartPanel=cartDrawer ? cartDrawer.querySelector(".gh-cart-drawer-root__panel"):null;var cartBackdrop=cartDrawer ? cartDrawer.querySelector("[data-gh-cart-drawer-backdrop]"):null;var cartBody=cartDrawer ? cartDrawer.querySelector("[data-gh-cart-drawer-body]"):null;var cartFooter=cartDrawer ? cartDrawer.querySelector("[data-gh-cart-drawer-footer]"):null;var cartShipping=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-shipping]"):null;var cartOffer=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-offer]"):null;var cartLive=cartDrawer ? cartDrawer.querySelector("[data-gh-cart-live]"):null;var cartDropPrice=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-drop-price]"):null;var cartBeforePrice=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-before-price]"):null;var cartSavings=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-savings]"):null;var cartSubtotal=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-subtotal]"):null;var cartShippingText=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-shipping-text]"):null;var cartShippingValue=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-shipping-value]"):null;var cartShippingProgress=cartDrawer ? cartDrawer.querySelector("[data-gh-drawer-shipping-progress]"):null;var controller=new AbortController();var signal=controller.signal;var timers=new Set();var hoverTimer=null;var lastMenuFocus=null;var lastCartFocus=null;var parsedInitialCartCount=Number(header.dataset.ghCartCount);var lastCartCount=Number.isFinite(parsedInitialCartCount)
? Math.max(0,Math.trunc(parsedInitialCartCount))
:0;var cartCache=null;var cartCacheTime=0;var cartFetchPromise=null;var cartFetchController=null;var cartChangeController=null;var cartStateVersion=0;var lastFastAddTime=0;var pendingAddFallbackTimer=null;var scheduledCartRefreshTimer=null;var scheduledCartRefreshOptions=null;var backgroundInertElements=[];var mobileStickyBars=[];var shippingWasUnlocked=false;var currency=header.dataset.ghCurrency||"EUR";var moneyFormatter=null;try{moneyFormatter=new Intl.NumberFormat(document.documentElement.lang||"de-DE",{style:"currency",
currency:currency
});}catch(error){moneyFormatter=null;}var parsedShippingThreshold=Number(header.dataset.ghFreeShippingThreshold);var freeShippingThreshold=Number.isFinite(parsedShippingThreshold)
? Math.max(0,parsedShippingThreshold)
:10000;var desktopMedia=window.matchMedia("(min-width: 1181px)");var mobileStickyMedia=window.matchMedia("(max-width: 749px)");var reduceMotionMedia=window.matchMedia("(prefers-reduced-motion: reduce)");var reduceMotion=reduceMotionMedia.matches;var lastObservedDrawerOpen=Boolean(
cartDrawer&&cartDrawer.classList.contains("is-open")
);var recentAddFingerprints=new Map();function listen(target,type,handler,options){if(!target)return;var config=typeof options==="boolean" ?{capture:options}:Object.assign({},options||{});config.signal=signal;target.addEventListener(type,handler,config);}function listenMedia(query,handler){if(!query||typeof handler!=="function")return;if(typeof query.addEventListener==="function"){listen(query,"change",handler);return;}if(typeof query.addListener==="function"){query.addListener(handler);signal.addEventListener("abort",function(){if(typeof query.removeListener==="function"){query.removeListener(handler);}},{once:true});}}function later(callback,delay){var timer=window.setTimeout(function(){timers.delete(timer);callback();},delay);timers.add(timer);return timer;}function clearTimer(timer){if(!timer)return;window.clearTimeout(timer);timers.delete(timer);}function stableObjectSignature(value){if(!value||typeof value!=="object")return "";try{if(Array.isArray(value))return JSON.stringify(value);var orderedValue={};Object.keys(value).sort().forEach(function(key){orderedValue[key]=value[key];});return JSON.stringify(orderedValue);}catch(error){return "";}}function lineItemIdentifier(item){if(!item||typeof item!=="object")return "";return String(item.id||item.variant_id||item.variantId||"");}function lineItemSellingPlanIdentifier(item){if(!item||typeof item!=="object")return "";var allocation=item.selling_plan_allocation;var sellingPlan=allocation&&allocation.selling_plan
? allocation.selling_plan
:null;return String(
item.selling_plan||
item.selling_plan_id||
(sellingPlan&&(sellingPlan.id||sellingPlan.name))||
""
);}function sameLineIdentity(firstItem,secondItem){if(!firstItem||!secondItem)return false;if(firstItem.key&&secondItem.key){return String(firstItem.key)===String(secondItem.key);}var firstIdentifier=lineItemIdentifier(firstItem);var secondIdentifier=lineItemIdentifier(secondItem);if(!firstIdentifier||firstIdentifier!==secondIdentifier)return false;return(
stableObjectSignature(firstItem.properties)===
stableObjectSignature(secondItem.properties)&&
lineItemSellingPlanIdentifier(firstItem)===
lineItemSellingPlanIdentifier(secondItem)
);}function cartAddFingerprint(detail){var payload=detail&&typeof detail==="object" ? detail:{};var suppliedItems=Array.isArray(payload.items)? payload.items:[];var item=payload.item||(suppliedItems.length===1 ? suppliedItems[0]:null)||payload;var identifier=
item&&(item.key||item.id||item.variant_id||item.variantId)||
payload.key||
payload.id||
payload.variant_id||
payload.variantId||
"";var quantity=
item&&item.quantity!=null
? item.quantity
:payload.quantity!=null
? payload.quantity
:"";var cartCount=
payload.cart&&payload.cart.item_count!=null
? payload.cart.item_count
:payload.item_count!=null
? payload.item_count
:"";var properties=stableObjectSignature(item&&item.properties);var sellingPlan=lineItemSellingPlanIdentifier(item);if(!identifier&&cartCount==="")return "";return[
String(identifier),
properties,
sellingPlan,
String(quantity),
String(cartCount)
].join("|");}function markAddHandled(detail){lastFastAddTime=Date.now();var fingerprint=cartAddFingerprint(detail);if(!fingerprint)return;recentAddFingerprints.set(fingerprint,lastFastAddTime);if(recentAddFingerprints.size>12){recentAddFingerprints.forEach(function(timestamp,key){if(lastFastAddTime - timestamp>2500){recentAddFingerprints.delete(key);}});}}function detailAlreadyReflectedInCart(detail){if(!cartCache||!Array.isArray(cartCache.items))return false;var payload=detail&&typeof detail==="object" ? detail:{};var suppliedItems=Array.isArray(payload.items)? payload.items:[];var item=payload.item||(suppliedItems.length===1 ? suppliedItems[0]:null)||payload;var key=item&&item.key ? String(item.key):"";var identifier=item&&(item.id||item.variant_id||item.variantId);var quantity=Number(item&&item.quantity);if(!key&&!identifier)return false;var cachedItem=cartCache.items.find(function(candidate){if(!candidate)return false;if(key&&candidate.key&&String(candidate.key)===key)return true;return sameLineIdentity(item,candidate);});if(!cachedItem)return false;if(!Number.isFinite(quantity))return true;return Number(cachedItem.quantity||0)>=quantity;}function wasAddHandledRecently(detail,ttl){var now=Date.now();var fingerprint=cartAddFingerprint(detail);if(
fingerprint&&
recentAddFingerprints.has(fingerprint)&&
now - recentAddFingerprints.get(fingerprint)<ttl
){return true;}if(
now - lastFastAddTime<ttl&&
detailAlreadyReflectedInCart(detail)
){return true;}return !fingerprint&&now - lastFastAddTime<Math.min(ttl,250);}function scheduleCartRefresh(options,delay){var incoming=Object.assign({pulse:true,
renderWhenOpen:true,
force:false,
allowFreshCache:false,
silent:true,
announceUpdate:true
},options||{});if(scheduledCartRefreshOptions){scheduledCartRefreshOptions.pulse=
scheduledCartRefreshOptions.pulse||incoming.pulse;scheduledCartRefreshOptions.renderWhenOpen=
scheduledCartRefreshOptions.renderWhenOpen||incoming.renderWhenOpen;scheduledCartRefreshOptions.force=
scheduledCartRefreshOptions.force||incoming.force;scheduledCartRefreshOptions.allowFreshCache=
scheduledCartRefreshOptions.allowFreshCache&&incoming.allowFreshCache;scheduledCartRefreshOptions.silent=
scheduledCartRefreshOptions.silent&&incoming.silent;scheduledCartRefreshOptions.announceUpdate=
scheduledCartRefreshOptions.announceUpdate||incoming.announceUpdate;}else{scheduledCartRefreshOptions=incoming;}clearTimer(scheduledCartRefreshTimer);scheduledCartRefreshTimer=later(function(){var settings=scheduledCartRefreshOptions;scheduledCartRefreshTimer=null;scheduledCartRefreshOptions=null;if(signal.aborted||!settings)return;refreshCart(settings).catch(function(){});},Number(delay||100));}function refreshMobileStickyBars(){mobileStickyBars=Array.from(
document.querySelectorAll(".gh-mobile-sticky-buy")
);}function isDesktop(){return desktopMedia.matches;}function shopRoot(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root
? window.Shopify.routes.root
: "/";}function escapeHTML(value){return String(value==null ? "":value)
.replace(/&/g, "&amp;")
.replace(/</g, "&lt;")
.replace(/>/g, "&gt;")
.replace(/"/g, "&quot;")
.replace(/'/g, "&#039;");}function text(key,fallback){return typeof strings[key]==="string"&&strings[key]
? strings[key]
:fallback;}function setTextContent(element,value){if(!element)return;var nextValue=String(value==null ? "":value);if(element.textContent!==nextValue){element.textContent=nextValue;}}function announce(message){if(!cartLive||!message)return;cartLive.textContent="";later(function(){cartLive.textContent=message;},20);}function track(action,detail){if(!trackingEnabled||!action)return;var payload=Object.assign({event:"gh_header_interaction",
gh_action:action,
gh_section_id:instanceKey,
gh_page_path:window.location.pathname
},detail||{});try{if(!Array.isArray(window.dataLayer))window.dataLayer=[];window.dataLayer.push(payload);header.dispatchEvent(new CustomEvent("gymhawk:header-interaction",{bubbles:true,
detail:payload
}));}catch(error){}}function safePropertyURL(value){var candidate=String(value||"").trim();if (!/^(https?:\/\/|\/)/i.test(candidate)) return "";try{var url=new URL(candidate,window.location.origin);return url.protocol==="http:"||url.protocol==="https:" ? url.href:"";}catch(error){return "";}}function formatMoney(cents){var safeCents=Number.isFinite(Number(cents))? Number(cents):0;if (moneyFormatter) return moneyFormatter.format(safeCents / 100);return (safeCents / 100).toFixed(2).replace(".", ",") + " " + currency;}function cartSignature(cart){if(!cart||typeof cart!=="object")return "";var items=Array.isArray(cart.items)
? cart.items.map(function(item){var featuredImageURL=item&&item.featured_image
? item.featured_image.url||""
:"";var sellingPlanName=
item&&
item.selling_plan_allocation&&
item.selling_plan_allocation.selling_plan
? item.selling_plan_allocation.selling_plan.name||""
:"";return[
item&&(item.key||item.id||""),
item&&item.quantity!=null ? item.quantity:"",
item&&item.final_line_price!=null ? item.final_line_price:item&&item.line_price!=null ? item.line_price:"",
item&&item.original_line_price!=null ? item.original_line_price:"",
item&&(item.product_title||item.title||""),
item&&item.variant_title ? item.variant_title:"",
item&&item.url ? item.url:"",
featuredImageURL,
sellingPlanName,
stableObjectSignature(item&&item.properties),
stableObjectSignature(item&&item.discounts),
stableObjectSignature(item&&item.instructions)
].join(":");}).join("|")
:"";return[
Number(cart.item_count||0),
Number(cart.total_price||0),
Number(cart.total_discount||0),
items
].join("~");}function getFocusable(container){if(!container)return[];return Array.from(
container.querySelectorAll(
'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
)
).filter(function(element){return(
!element.hidden&&
!element.closest("[inert]")&&
element.getAttribute("aria-hidden")!=="true"&&
element.getClientRects().length>0
);});}function trapFocus(event,container){if(event.key!=="Tab"||!container)return;var focusable=getFocusable(container);if(!focusable.length){event.preventDefault();container.focus();return;}var first=focusable[0];var last=focusable[focusable.length - 1];var activeElement=document.activeElement;var focusIsInside=activeElement&&container.contains(activeElement);if(!focusIsInside){event.preventDefault();(event.shiftKey ? last:first).focus();return;}if(event.shiftKey&&(activeElement===first||activeElement===container)){event.preventDefault();last.focus();}else if(!event.shiftKey&&activeElement===last){event.preventDefault();first.focus();}}function restoreBackgroundInert(){backgroundInertElements.forEach(function(element){if(element&&element.dataset.ghInertByHeader===instanceKey){element.removeAttribute("inert");delete element.dataset.ghInertByHeader;}});backgroundInertElements=[];}function markBackgroundInert(element){if(!element||element.hasAttribute("inert"))return;element.setAttribute("inert","");element.dataset.ghInertByHeader=instanceKey;backgroundInertElements.push(element);}function syncBackgroundInert(){restoreBackgroundInert();var cartIsOpen=Boolean(cartDrawer&&cartDrawer.classList.contains("is-open"));var menuIsOpen=header.classList.contains("is-mobile-open");if(!cartIsOpen&&!menuIsOpen)return;Array.from(document.body.children).forEach(function(child){if(child===sectionRoot||child.contains(sectionRoot))return;markBackgroundInert(child);});if(sectionRoot&&sectionRoot.parentElement){Array.from(sectionRoot.parentElement.children).forEach(function(sibling){if(sibling!==sectionRoot)markBackgroundInert(sibling);});}if(cartIsOpen){markBackgroundInert(header);markBackgroundInert(mobileBackdrop);}else if(menuIsOpen){markBackgroundInert(header.querySelector(".gh-mega-header__brand"));markBackgroundInert(mobileToggle);markBackgroundInert(header.querySelector(".gh-mega-header__actions"));}}function syncPageLock(){var overlayOpen=
header.classList.contains("is-mobile-open")||
(cartDrawer&&cartDrawer.classList.contains("is-open"));document.documentElement.classList.toggle("gh-overlay-open",Boolean(overlayOpen));document.body.classList.toggle("gh-overlay-open",Boolean(overlayOpen));if(sectionRoot){sectionRoot.classList.toggle("gh-layer-active",Boolean(overlayOpen));}syncBackgroundInert();}function closeMega(item){if(!item)return;item.classList.remove("is-open");var trigger=item.querySelector(".gh-mega-header__mega-trigger");var panel=item.querySelector(".gh-mega-menu");if(trigger)trigger.setAttribute("aria-expanded","false");if(panel){panel.setAttribute("aria-hidden","true");panel.setAttribute("inert","");}}function closeAllMega(exceptItem){megaItems.forEach(function(item){if(item!==exceptItem)closeMega(item);});}function openMega(item){if(!item)return;var wasOpen=item.classList.contains("is-open");closeAllMega(item);item.classList.add("is-open");var trigger=item.querySelector(".gh-mega-header__mega-trigger");var panel=item.querySelector(".gh-mega-menu");if(trigger)trigger.setAttribute("aria-expanded","true");if(panel){panel.setAttribute("aria-hidden","false");panel.removeAttribute("inert");}if(!wasOpen){track("mega_menu_open",{gh_menu_label:trigger ? trigger.textContent.trim():""
});}}function updateNavigationAria(){if(!mobileNav)return;if(isDesktop()){mobileNav.removeAttribute("aria-hidden");mobileNav.removeAttribute("inert");}else{var menuOpen=header.classList.contains("is-mobile-open");mobileNav.setAttribute("aria-hidden",menuOpen ? "false":"true");if(menuOpen)mobileNav.removeAttribute("inert");else mobileNav.setAttribute("inert","");}}function openMobileMenu(){if(isDesktop()||!mobileNav)return;closeCartDrawer(false);lastMenuFocus=document.activeElement;header.classList.add("is-mobile-open");mobileToggle&&mobileToggle.setAttribute("aria-expanded","true");updateNavigationAria();syncPageLock();track("mobile_menu_open");later(function(){var closeButton=header.querySelector("[data-gh-mobile-menu-close]");if(closeButton)closeButton.focus();},35);}function closeMobileMenu(restoreFocus){var wasOpen=header.classList.contains("is-mobile-open");header.classList.remove("is-mobile-open");mobileToggle&&mobileToggle.setAttribute("aria-expanded","false");closeAllMega();updateNavigationAria();syncPageLock();if(wasOpen&&restoreFocus!==false&&lastMenuFocus&&typeof lastMenuFocus.focus==="function"){later(function(){lastMenuFocus.focus();},25);}if(wasOpen)track("mobile_menu_close");}function renderCount(count,pulse){var parsedCount=Number(count);var safeCount=Number.isFinite(parsedCount)
? Math.max(0,Math.trunc(parsedCount))
:0;var itemLabel=safeCount===1
? text("item","Artikel")
:text("items","Artikel");var cartLabel=text("openCart","Warenkorb")+ ": " +(
safeCount>0
? safeCount + " " + itemLabel
:text("empty","Leer")
);if(countBubble){setTextContent(countBubble,safeCount);countBubble.classList.toggle("is-active",safeCount>0);}setTextContent(mobileCartCount,safeCount);if(statusText){setTextContent(statusText,safeCount>0
? safeCount + " " + itemLabel
:text("empty","Leer"));}cartOpenButtons.forEach(function(button){if(button.getAttribute("aria-label")!==cartLabel){button.setAttribute("aria-label",cartLabel);}});if(header.dataset.ghCartCount!==String(safeCount)){header.dataset.ghCartCount=String(safeCount);}if(pulse&&safeCount!==lastCartCount){header.classList.remove("is-cart-pulsing");window.requestAnimationFrame(function(){if(signal.aborted)return;header.classList.add("is-cart-pulsing");later(function(){header.classList.remove("is-cart-pulsing");},540);});}lastCartCount=safeCount;}function abortCartFetch(){if(cartFetchController){cartFetchController.abort();cartFetchController=null;}cartFetchPromise=null;}function fetchCart(options){var settings=Object.assign({force:false,
allowFreshCache:false
},options||{});var cacheIsFresh=
cartCache&&
Date.now()- cartCacheTime<3500;if(!settings.force&&settings.allowFreshCache&&cacheIsFresh){return Promise.resolve(cartCache);}if(!settings.force&&cartFetchPromise){return cartFetchPromise;}if(settings.force){abortCartFetch();}var requestVersion=cartStateVersion;var controllerForRequest=new AbortController();var requestTimedOut=false;var requestTimeout=window.setTimeout(function(){requestTimedOut=true;controllerForRequest.abort();},12000);cartFetchController=controllerForRequest;cartFetchPromise=fetch(shopRoot()+ "cart.js",{method:"GET",
headers:{"Accept": "application/json",
"X-Requested-With":"XMLHttpRequest"
},
credentials:"same-origin",
cache:"no-store",
signal:controllerForRequest.signal
})
.then(function(response){if(!response.ok){throw new Error("Cart could not be loaded.");}return response.json();})
.then(function(cart){if(requestVersion<cartStateVersion&&cartCache){return cartCache;}cartCache=cart;cartCacheTime=Date.now();return cart;})
.catch(function(error){if(requestTimedOut){var timeoutError=new Error("Cart request timed out.");timeoutError.name="TimeoutError";throw timeoutError;}throw error;})
.finally(function(){window.clearTimeout(requestTimeout);if(cartFetchController===controllerForRequest){cartFetchController=null;cartFetchPromise=null;}});return cartFetchPromise;}function sizedImageURL(source,width){if(!source)return "";return source +(source.indexOf("?")===-1 ? "?":"&")+ "width=" + Number(width||240);}function renderLineItemProperties(item){if(!showLineItemProperties||!item||!item.properties||typeof item.properties!=="object"){return "";}var properties=Object.keys(item.properties).filter(function(key){var value=item.properties[key];return key.charAt(0)!=="_"&&value!==null&&value!==undefined&&String(value).trim()!=="";});if(!properties.length)return "";var rows=properties.map(function(key){var rawValue=item.properties[key];var propertyURL=safePropertyURL(rawValue);var valueHTML=propertyURL
? '<a href="' + escapeHTML(propertyURL) + '" target="_blank" rel="noopener">' + escapeHTML(text("file", "Datei ansehen")) + '</a>'
:escapeHTML(rawValue);return '<p class="gh-cart-drawer-root__item-property"><strong>' + escapeHTML(key) + ':</strong> ' + valueHTML + '</p>';}).join("");return '<div class="gh-cart-drawer-root__item-properties" aria-label="' + escapeHTML(text("properties", "Produktdetails")) + '">' + rows + '</div>';}function renderLineDiscounts(item){if(!item||!Array.isArray(item.discounts)||!item.discounts.length)return "";return item.discounts.map(function(discount){return discount&&discount.title
? '<div class="gh-cart-drawer-root__item-discount">' + escapeHTML(discount.title) + '</div>'
:"";}).join("");}function setCartBusy(isBusy){if(!cartDrawer)return;cartDrawer.classList.toggle("is-loading",Boolean(isBusy));cartDrawer.setAttribute("aria-busy",isBusy ? "true":"false");cartDrawer.querySelectorAll("[data-gh-cart-mutation], [data-gh-track='checkout_click']").forEach(function(control){if(isBusy){control.disabled=true;}else if(!control.hasAttribute("data-gh-static-disabled")){control.disabled=false;}});}function renderCartError(){if(!cartBody)return;delete cartBody.dataset.ghCartSignature;cartBody.innerHTML=
'<div class="gh-cart-drawer-root__error">' +
'<strong>' + escapeHTML(text("errorTitle", "Warenkorb konnte nicht geladen werden")) + '</strong>' +
'<span>' + escapeHTML(text("errorBody", "Bitte versuche es erneut.")) + '</span>' +
'<button class="gh-cart-drawer-root__retry" type="button" data-gh-cart-retry>' + escapeHTML(text("retry", "Erneut versuchen")) + '</button>' +
'</div>';if(cartFooter)cartFooter.hidden=true;setCartBusy(false);announce(text("errorTitle","Warenkorb konnte nicht geladen werden"));}function renderDrawer(cart,options){if(!cartDrawer||!cartBody||!cartFooter||!cart)return;var renderSettings=Object.assign({announceUpdate:true,
forceRender:false
},options||{});cartCache=cart;cartCacheTime=Date.now();var nextCartSignature=cartSignature(cart);if(
!renderSettings.forceRender&&
nextCartSignature&&
cartBody.dataset.ghCartSignature===nextCartSignature
){renderCount(Number(cart.item_count||0),false);return;}var parsedCartCount=Number(cart.item_count);var itemCount=Number.isFinite(parsedCartCount)
? Math.max(0,Math.trunc(parsedCartCount))
:0;var parsedSubtotal=Number(cart.total_price);var subtotal=Number.isFinite(parsedSubtotal)
? Math.max(0,parsedSubtotal)
:0;renderCount(itemCount,true);if(!itemCount||!Array.isArray(cart.items)||cart.items.length===0){cartBody.innerHTML=
'<div class="gh-cart-drawer-root__empty">' +
'<strong>' + escapeHTML(text("emptyTitle", "Dein Warenkorb ist leer")) + '</strong>' +
'<span>' + escapeHTML(text("emptyBody", "Entdecke den aktuellen GYMHAWK Drop.")) + '</span>' +
'</div>';cartBody.dataset.ghCartSignature=nextCartSignature;cartFooter.hidden=true;if(cartOffer)cartOffer.hidden=true;setCartBusy(false);if(renderSettings.announceUpdate&&cartDrawer.classList.contains("is-open")){announce(text("cartUpdated","Warenkorb aktualisiert"));}return;}var itemsHTML=cart.items.map(function(item,index){var productTitle=item.product_title||item.title||text("genericProduct","GYMHAWK Produkt");var image=item.featured_image&&item.featured_image.url
? item.featured_image.url
:item.image||"";var imageAlt=item.featured_image&&item.featured_image.alt
? item.featured_image.alt
:productTitle;var itemURL=item.url ? safePropertyURL(item.url):"";if(itemURL)itemURL=escapeHTML(itemURL);var imageLoadingAttributes=index===0
? ' loading="eager" fetchpriority="high" decoding="async"'
:' loading="lazy" decoding="async"';var imageHTML=image
? '<img src="' + escapeHTML(sizedImageURL(image,240))+ '" alt="' + escapeHTML(imageAlt)+ '"' + imageLoadingAttributes + '>'
: '<span class="gh-cart-drawer-root__item-placeholder">GYMHAWK</span>';var mediaHTML=itemURL
? '<a class="gh-cart-drawer-root__item-media" href="' + itemURL + '" data-gh-track="cart_product_click">' + imageHTML + '</a>'
: '<div class="gh-cart-drawer-root__item-media">' + imageHTML + '</div>';var titleHTML=itemURL
? '<a class="gh-cart-drawer-root__item-title" href="' + itemURL + '" data-gh-track="cart_product_click">' + escapeHTML(productTitle) + '</a>'
: '<span class="gh-cart-drawer-root__item-title">' + escapeHTML(productTitle) + '</span>';var variant=item.variant_title&&item.variant_title!=="Default Title"
? '<div class="gh-cart-drawer-root__item-variant">' + escapeHTML(item.variant_title) + '</div>'
:'';var sellingPlanName=item.selling_plan_allocation&&item.selling_plan_allocation.selling_plan
? item.selling_plan_allocation.selling_plan.name
:"";if(sellingPlanName){variant += '<div class="gh-cart-drawer-root__item-variant">' + escapeHTML(sellingPlanName) + '</div>';}var finalLinePrice=Number(
item.final_line_price!=null
? item.final_line_price
:item.line_price||0
);var originalLinePrice=Number(
item.original_line_price!=null
? item.original_line_price
:finalLinePrice
);var priceHTML=formatMoney(finalLinePrice);var canUpdateQuantity=!item.instructions||item.instructions.can_update_quantity!==false;var canRemove=!item.instructions||item.instructions.can_remove!==false;var parsedItemQuantity=Number(item.quantity);var currentItemQuantity=Number.isFinite(parsedItemQuantity)
? Math.max(1,Math.trunc(parsedItemQuantity))
:1;var updateDisabled=canUpdateQuantity ? "":' disabled data-gh-static-disabled aria-disabled="true"';var minusDisabled=canUpdateQuantity&&(currentItemQuantity>1||canRemove)
? ""
:' disabled data-gh-static-disabled aria-disabled="true"';var lineKeyAttribute=item.key
? ' data-gh-drawer-key="' + escapeHTML(item.key)+ '"'
:"";if(originalLinePrice>finalLinePrice){priceHTML += '<s>' + formatMoney(originalLinePrice) + '</s>';}var removeButton=canRemove
? '<button class="gh-cart-drawer-root__remove" type="button" data-gh-drawer-remove data-gh-cart-mutation>' + escapeHTML(text("remove", "Entfernen")) + '</button>'
:"";return(
'<article class="gh-cart-drawer-root__item" data-gh-drawer-line="' +(index + 1)+ '"' + lineKeyAttribute + '>' +
mediaHTML +
'<div class="gh-cart-drawer-root__item-info">' +
titleHTML +
variant +
renderLineDiscounts(item)+
renderLineItemProperties(item)+
'<div class="gh-cart-drawer-root__item-bottom">' +
'<div>' +
'<div class="gh-cart-drawer-root__item-price">' + priceHTML + '</div>' +
removeButton +
'</div>' +
'<div class="gh-cart-drawer-root__qty" role="group" aria-label="' + escapeHTML(text("quantity","Menge ändern"))+ '">' +
'<button type="button" data-gh-drawer-minus data-gh-cart-mutation aria-label="' + escapeHTML(text("decrease", "Menge reduzieren")) + '"' + minusDisabled + '>−</button>' +
'<span aria-live="polite">' + currentItemQuantity + '</span>' +
'<button type="button" data-gh-drawer-plus data-gh-cart-mutation aria-label="' + escapeHTML(text("increase", "Menge erhöhen")) + '"' + updateDisabled + '>+</button>' +
'</div>' +
'</div>' +
'</div>' +
'</article>'
);}).join("");cartBody.innerHTML = '<div class="gh-cart-drawer-root__items">' + itemsHTML + '</div>';cartBody.dataset.ghCartSignature=nextCartSignature;var originalTotal=Number(
cart.original_total_price!=null
? cart.original_total_price
:subtotal
);if(!Number.isFinite(originalTotal))originalTotal=subtotal;var reportedDiscount=Number(cart.total_discount||0);if(!Number.isFinite(reportedDiscount))reportedDiscount=0;var savings=Math.max(
0,
reportedDiscount,
originalTotal - subtotal
);var displayedOriginalTotal=Math.max(originalTotal,subtotal + savings);var hasRealSavings=savings>0;var shippingLeft=Math.max(0,freeShippingThreshold - subtotal);var shippingProgress=freeShippingThreshold>0
? Math.min(100, Math.round((subtotal / freeShippingThreshold) * 100))
:100;if(cartShipping)cartShipping.hidden=freeShippingThreshold<=0;setTextContent(cartDropPrice,formatMoney(subtotal));setTextContent(cartBeforePrice,formatMoney(displayedOriginalTotal));setTextContent(cartSavings,formatMoney(savings));setTextContent(cartSubtotal,formatMoney(subtotal));setTextContent(
cartShippingText,
shippingLeft<=0
? text("shippingActive","Kostenloser Versand aktiviert")
:text("shippingUntil","Bis zum kostenlosen Versand")
);setTextContent(
cartShippingValue,
shippingLeft<=0 ? text("unlocked","Freigeschaltet"):formatMoney(shippingLeft)
);if(cartOffer)cartOffer.hidden=!hasRealSavings;if(
cartShippingProgress&&
cartShippingProgress.style.width!==shippingProgress + "%"
){cartShippingProgress.style.width=shippingProgress + "%";}cartFooter.hidden=false;setCartBusy(false);if(shippingLeft<=0&&freeShippingThreshold>0&&!shippingWasUnlocked){shippingWasUnlocked=true;track("free_shipping_unlocked",{gh_cart_total:subtotal});}else if(shippingLeft>0){shippingWasUnlocked=false;}if(renderSettings.announceUpdate&&cartDrawer.classList.contains("is-open")){announce(text("cartUpdated","Warenkorb aktualisiert"));}}function normalizeAddedItem(rawItem){if(!rawItem||typeof rawItem!=="object")return null;var rawQuantity=Number(rawItem.quantity);var quantity=Number.isFinite(rawQuantity)
? Math.max(1,Math.trunc(rawQuantity))
:1;var unitPrice=Number(
rawItem.final_price!=null
? rawItem.final_price
:rawItem.discounted_price!=null
? rawItem.discounted_price
:rawItem.price||0
);if(!Number.isFinite(unitPrice))unitPrice=0;var linePrice=Number(
rawItem.final_line_price!=null
? rawItem.final_line_price
:rawItem.line_price!=null
? rawItem.line_price
:unitPrice * quantity
);if(!Number.isFinite(linePrice))linePrice=unitPrice * quantity;var originalLinePrice=Number(
rawItem.original_line_price!=null
? rawItem.original_line_price
:linePrice
);if(!Number.isFinite(originalLinePrice))originalLinePrice=linePrice;return Object.assign({},rawItem,{quantity:quantity,
final_line_price:linePrice,
line_price:Number(rawItem.line_price!=null ? rawItem.line_price:linePrice),
original_line_price:originalLinePrice,
product_title:
rawItem.product_title||
rawItem.title||
text("genericProduct","GYMHAWK Produkt")
});}function buildOptimisticCart(addedItem){var item=normalizeAddedItem(addedItem);if(!item)return null;if(!cartCache||!Array.isArray(cartCache.items)){if(lastCartCount>0)return null;return{item_count:item.quantity,
total_price:Number(item.final_line_price||0),
original_total_price:Number(item.original_line_price||item.final_line_price||0),
total_discount:Math.max(0,Number(item.original_line_price||0)- Number(item.final_line_price||0)),
items:[item]
};}var clonedItems=cartCache.items.map(function(existingItem){return Object.assign({},existingItem);});var matchingIndex=clonedItems.findIndex(function(existingItem){return sameLineIdentity(item,existingItem);});var quantityDelta=item.quantity;var finalPriceDelta=Number(item.final_line_price||0);var originalPriceDelta=Number(
item.original_line_price!=null
? item.original_line_price
:item.final_line_price||0
);if(matchingIndex>=0){var existing=clonedItems[matchingIndex];var existingFinalLinePrice=Number(
existing.final_line_price!=null
? existing.final_line_price
:existing.line_price||0
);var existingOriginalLinePrice=Number(
existing.original_line_price!=null
? existing.original_line_price
:existing.final_line_price!=null
? existing.final_line_price
:existing.line_price||0
);quantityDelta=Math.max(
0,
Number(item.quantity||0)- Number(existing.quantity||0)
);finalPriceDelta=
Number(item.final_line_price||0)- existingFinalLinePrice;originalPriceDelta=
Number(item.original_line_price!=null ? item.original_line_price:item.final_line_price||0)-
existingOriginalLinePrice;existing=Object.assign({},existing,item);clonedItems.splice(matchingIndex,1);clonedItems.unshift(existing);}else{clonedItems.unshift(item);}var optimisticTotal=Math.max(
0,
Number(cartCache.total_price||0)+ finalPriceDelta
);var optimisticOriginalTotal=Math.max(
optimisticTotal,
Number(cartCache.original_total_price!=null ? cartCache.original_total_price:cartCache.total_price||0)+
originalPriceDelta
);var optimisticDiscount=Math.max(
0,
Number(cartCache.total_discount||0)+
(originalPriceDelta - finalPriceDelta),
optimisticOriginalTotal - optimisticTotal
);return{item_count:
Math.max(0,Number(cartCache.item_count||0)+ quantityDelta),
total_price:optimisticTotal,
original_total_price:optimisticOriginalTotal,
total_discount:optimisticDiscount,
items:clonedItems
};}function renderAddedItemInstantly(addedItem){var normalizedItem=normalizeAddedItem(addedItem);if(!normalizedItem)return false;var optimisticCart=buildOptimisticCart(addedItem);cartStateVersion+=1;markAddHandled(addedItem);abortCartFetch();if(!optimisticCart){renderCount(lastCartCount,false);openCartDrawer({cart:null,
backgroundRefresh:false,
focusPanel:true
});if(cartBody){delete cartBody.dataset.ghCartSignature;cartBody.innerHTML=
'<div class="gh-cart-drawer-root__loading">' +
escapeHTML(text("syncing","Dein Warenkorb wird synchronisiert…"))+
'</div>';}if(cartFooter)cartFooter.hidden=true;setCartBusy(true);refreshCart({pulse:false,
renderWhenOpen:true,
force:true,
silent:false
}).catch(function(){});return true;}cartCache=optimisticCart;cartCacheTime=Date.now();openCartDrawer({cart:optimisticCart,
backgroundRefresh:false,
focusPanel:true
});refreshCart({pulse:true,
renderWhenOpen:true,
force:true,
silent:true
}).catch(function(){});return true;}function refreshCart(options){var settings=Object.assign({pulse:true,
renderWhenOpen:true,
force:false,
allowFreshCache:false,
silent:false,
announceUpdate:true
},options||{});return fetchCart({force:settings.force,
allowFreshCache:settings.allowFreshCache
})
.then(function(cart){renderCount(Number(cart.item_count||0),settings.pulse);if(
settings.renderWhenOpen&&
cartDrawer&&
cartDrawer.classList.contains("is-open")
){renderDrawer(cart,{announceUpdate:settings.announceUpdate
});}return cart;})
.catch(function(error){if(
!settings.silent&&
error&&
error.name!=="AbortError"&&
cartDrawer&&
cartDrawer.classList.contains("is-open")
){renderCartError();}throw error;});}function isMobileStickyViewport(){return mobileStickyMedia.matches;}function setMobileStickyBuyHidden(shouldHide){var hidden=Boolean(shouldHide&&isMobileStickyViewport());document.body.classList.toggle(
"gh-cart-drawer-mobile-open",
hidden
);if(!mobileStickyBars.length||mobileStickyBars.some(function(stickyBar){return !stickyBar||!stickyBar.isConnected;})){refreshMobileStickyBars();}mobileStickyBars.forEach(function(stickyBar){var stateKey="ghCartDrawerStickyHidden";if(hidden){if(stickyBar.dataset[stateKey]!=="true"){stickyBar.dataset[stateKey]="true";stickyBar.dataset.ghPreviousDisplay=
stickyBar.style.getPropertyValue("display")||"";stickyBar.dataset.ghPreviousDisplayPriority=
stickyBar.style.getPropertyPriority("display")||"";stickyBar.dataset.ghPreviousAriaHidden=
stickyBar.hasAttribute("aria-hidden")
? stickyBar.getAttribute("aria-hidden")
:"__none__";stickyBar.dataset.ghPreviousInert=
stickyBar.hasAttribute("inert")? "true":"false";}stickyBar.style.setProperty("display","none","important");stickyBar.setAttribute("aria-hidden","true");stickyBar.setAttribute("inert","");return;}if(stickyBar.dataset[stateKey]!=="true")return;var previousDisplay=stickyBar.dataset.ghPreviousDisplay||"";var previousPriority=
stickyBar.dataset.ghPreviousDisplayPriority||"";var previousAriaHidden=
stickyBar.dataset.ghPreviousAriaHidden||"__none__";var wasInert=stickyBar.dataset.ghPreviousInert==="true";if(previousDisplay){stickyBar.style.setProperty(
"display",
previousDisplay,
previousPriority
);}else{stickyBar.style.removeProperty("display");}if(previousAriaHidden==="__none__"){stickyBar.removeAttribute("aria-hidden");}else{stickyBar.setAttribute("aria-hidden",previousAriaHidden);}if(!wasInert){stickyBar.removeAttribute("inert");}delete stickyBar.dataset[stateKey];delete stickyBar.dataset.ghPreviousDisplay;delete stickyBar.dataset.ghPreviousDisplayPriority;delete stickyBar.dataset.ghPreviousAriaHidden;delete stickyBar.dataset.ghPreviousInert;});}function syncMobileStickyBuyWithCartDrawer(){setMobileStickyBuyHidden(
Boolean(
cartDrawer&&
cartDrawer.classList.contains("is-open")
)
);}function openCartDrawer(options){var settings=Object.assign({cart:null,
backgroundRefresh:true,
focusPanel:true,
ignoreCache:false
},options||{});if(!cartDrawer||!cartPanel){window.location.href=header.dataset.ghCartUrl||(shopRoot()+ "cart");return;}var opener=document.activeElement;var openedFromMobileMenu=Boolean(
mobileNav&&
opener&&
mobileNav.contains(opener)
);var wasOpen=cartDrawer.classList.contains("is-open");var visibleCartOpener=cartOpenButtons.find(function(button){return button&&button.getClientRects().length>0&&!button.closest("[inert]");});lastCartFocus=openedFromMobileMenu
? mobileToggle
:opener&&opener!==document.body&&opener!==document.documentElement
? opener
:visibleCartOpener||mobileToggle;closeMobileMenu(false);closeAllMega();cartDrawer.classList.add("is-open");cartDrawer.setAttribute("aria-hidden","false");cartDrawer.removeAttribute("inert");cartOpenButtons.forEach(function(button){button.setAttribute("aria-expanded","true");});lastObservedDrawerOpen=true;syncMobileStickyBuyWithCartDrawer();syncPageLock();if(!wasOpen){track("cart_open",{gh_cart_count:lastCartCount,
gh_source:openedFromMobileMenu ? "mobile_menu":"header"
});}var immediateCart=settings.cart||(settings.ignoreCache ? null:cartCache);if(immediateCart){renderDrawer(immediateCart,{announceUpdate:wasOpen
});}else{setCartBusy(true);if(cartBody){delete cartBody.dataset.ghCartSignature;cartBody.innerHTML=
'<div class="gh-cart-drawer-root__loading">' + escapeHTML(text("loadingCart", "Warenkorb wird geladen…")) + '</div>';}if(cartFooter)cartFooter.hidden=true;}if(settings.focusPanel){later(function(){cartPanel.focus();},10);}if(!settings.backgroundRefresh)return;refreshCart({pulse:false,
renderWhenOpen:true,
allowFreshCache:Boolean(immediateCart),
silent:Boolean(immediateCart),
announceUpdate:wasOpen
})
.catch(function(){})
.finally(function(){setCartBusy(false);});}function closeCartDrawer(restoreFocus){if(!cartDrawer)return;var wasOpen=cartDrawer.classList.contains("is-open");cartDrawer.classList.remove("is-open");cartDrawer.setAttribute("aria-hidden","true");cartDrawer.setAttribute("inert","");cartOpenButtons.forEach(function(button){button.setAttribute("aria-expanded","false");});lastObservedDrawerOpen=false;setCartBusy(false);syncMobileStickyBuyWithCartDrawer();syncPageLock();if(wasOpen&&restoreFocus!==false&&lastCartFocus&&typeof lastCartFocus.focus==="function"){later(function(){if(lastCartFocus&&lastCartFocus.isConnected)lastCartFocus.focus();},25);}if(wasOpen)track("cart_close");}function showCartMutationError(){if(!cartBody)return;var previousError=cartBody.querySelector(".gh-cart-drawer-root__inline-error");if(previousError)previousError.remove();cartBody.insertAdjacentHTML(
"afterbegin",
'<div class="gh-cart-drawer-root__inline-error" role="alert">' +
'<span>' + escapeHTML(text("mutationError", "Die Menge konnte nicht aktualisiert werden.")) + '</span>' +
'<button type="button" data-gh-cart-retry>' + escapeHTML(text("retry", "Erneut versuchen")) + '</button>' +
'</div>'
);announce(text("mutationError","Die Menge konnte nicht aktualisiert werden."));}function restoreCartMutationFocus(identifier,action){if(!cartDrawer||!cartDrawer.classList.contains("is-open"))return;var targetItem=null;var items=Array.from(cartDrawer.querySelectorAll("[data-gh-drawer-line]"));if(identifier&&identifier.key){targetItem=items.find(function(item){return String(item.getAttribute("data-gh-drawer-key")||"")===String(identifier.key);})||null;}if(!targetItem&&identifier&&identifier.line&&action!=="remove"){targetItem=items.find(function(item){return Number(item.getAttribute("data-gh-drawer-line"))===Number(identifier.line);})||null;}var selector=
action==="increase"
? "[data-gh-drawer-plus]"
:action==="decrease"
? "[data-gh-drawer-minus]"
:null;var focusTarget=selector&&targetItem
? targetItem.querySelector(selector)
:null;if(!focusTarget&&action==="remove"){var fallbackIndex=Math.max(0,Number(identifier&&identifier.line||1)- 1);var fallbackItem=items[Math.min(fallbackIndex,Math.max(0,items.length - 1))];focusTarget=fallbackItem
? fallbackItem.querySelector("[data-gh-drawer-plus], [data-gh-drawer-minus], a[href]")
:cartPanel;}if(!focusTarget)focusTarget=cartPanel;if(focusTarget&&typeof focusTarget.focus==="function"){window.requestAnimationFrame(function(){if(!signal.aborted&&focusTarget.isConnected){focusTarget.focus();}});}}function changeCartLine(identifier,quantity,action){if(!cartDrawer||!identifier||(!identifier.key&&!identifier.line))return;var focusAction=Number(quantity)<=0 ? "remove":action;if(cartChangeController)cartChangeController.abort();setCartBusy(true);cartStateVersion+=1;var changeVersion=cartStateVersion;var controllerForChange=new AbortController();cartChangeController=controllerForChange;var changeTimedOut=false;var changeTimeout=window.setTimeout(function(){changeTimedOut=true;controllerForChange.abort();},12000);var requestBody=identifier.key
?{id:String(identifier.key),quantity:Math.max(0,quantity)}:{line:Number(identifier.line),quantity:Math.max(0,quantity)};track(action==="remove" ? "cart_item_remove":"cart_quantity_change",{gh_quantity:Math.max(0,quantity)
});fetch(shopRoot() + "cart/change.js", {method:"POST",
headers:{"Content-Type": "application/json",
"Accept": "application/json"
},
credentials:"same-origin",
body:JSON.stringify(requestBody),
signal:controllerForChange.signal
})
.then(function(response){if(!response.ok)throw new Error("Cart change failed.");return response.json();})
.then(function(cart){if(changeVersion<cartStateVersion){return;}cartCache=cart;cartCacheTime=Date.now();renderCount(Number(cart.item_count||0),true);if(cartDrawer.classList.contains("is-open")){renderDrawer(cart);restoreCartMutationFocus(identifier,focusAction);}})
.catch(function(error){if(changeTimedOut||!error||error.name!=="AbortError"){showCartMutationError();}})
.finally(function(){window.clearTimeout(changeTimeout);if(cartChangeController===controllerForChange){cartChangeController=null;setCartBusy(false);}});}megaItems.forEach(function(item){listen(item,"mouseenter",function(){if(!isDesktop())return;clearTimer(hoverTimer);openMega(item);});listen(item,"mouseleave",function(){if(!isDesktop())return;clearTimer(hoverTimer);hoverTimer=later(function(){if(!item.contains(document.activeElement))closeMega(item);},120);});listen(item,"focusout",function(){later(function(){if(isDesktop()&&!item.contains(document.activeElement))closeMega(item);},0);});});megaTriggers.forEach(function(trigger){listen(trigger,"keydown",function(event){var item=trigger.closest(".gh-mega-header__nav-item--mega");if(!item||!isDesktop())return;if(event.key==="ArrowDown"){event.preventDefault();openMega(item);var firstLink=item.querySelector(".gh-mega-menu a[href]");if(firstLink)firstLink.focus();}else if(event.key==="Escape"){event.preventDefault();closeMega(item);trigger.focus();}});listen(trigger,"click",function(event){event.preventDefault();event.stopPropagation();var item=trigger.closest(".gh-mega-header__nav-item--mega");if(!item)return;if(isDesktop()){openMega(item);}else if(item.classList.contains("is-open")){closeMega(item);}else{openMega(item);later(function(){item.scrollIntoView({behavior:reduceMotion ? "auto":"smooth",block:"nearest"});},50);}});});listen(mobileToggle,"click",function(event){event.preventDefault();event.stopPropagation();if(header.classList.contains("is-mobile-open")){closeMobileMenu(true);}else{openMobileMenu();}});mobileCloseButtons.forEach(function(button){listen(button,"click",function(event){event.preventDefault();closeMobileMenu(true);});});listen(mobileBackdrop,"click",function(event){event.preventDefault();closeMobileMenu(true);});cartOpenButtons.forEach(function(button){listen(button,"click",function(event){event.preventDefault();event.stopPropagation();openCartDrawer();});});listen(cartBackdrop,"click",function(event){event.preventDefault();closeCartDrawer(true);});if(cartDrawer){listen(cartDrawer,"click",function(event){var closeButton=event.target.closest("[data-gh-cart-drawer-close]");if(closeButton){event.preventDefault();closeCartDrawer(true);return;}if(event.target.closest("[data-gh-cart-retry]")){event.preventDefault();setCartBusy(true);refreshCart({pulse:false,renderWhenOpen:true,force:true})
.catch(function(){})
.finally(function(){setCartBusy(false);});return;}var item=event.target.closest("[data-gh-drawer-line]");if(!item)return;var line=Number(item.getAttribute("data-gh-drawer-line"));var key=item.getAttribute("data-gh-drawer-key")||"";var identifier={key:key,line:line};var quantityElement=item.querySelector(".gh-cart-drawer-root__qty span");var currentQuantity=Number(quantityElement ? quantityElement.textContent:1)||1;if(event.target.closest("[data-gh-drawer-plus]")){event.preventDefault();changeCartLine(identifier,currentQuantity + 1,"increase");}else if(event.target.closest("[data-gh-drawer-minus]")){event.preventDefault();changeCartLine(identifier,Math.max(0,currentQuantity - 1),"decrease");}else if(event.target.closest("[data-gh-drawer-remove]")){event.preventDefault();changeCartLine(identifier,0,"remove");}});}listen(header,"click",function(event){var tracked=event.target.closest("[data-gh-track]");if(tracked){track(tracked.getAttribute("data-gh-track"),{gh_label:tracked.textContent.trim(),
gh_url:tracked.getAttribute("href")||""
});return;}var navigationLink=event.target.closest("a.gh-mega-header__nav-link, .gh-mega-menu a[href]");if(navigationLink){track("navigation_click",{gh_label:navigationLink.textContent.trim(),
gh_url:navigationLink.getAttribute("href")||""
});}});listen(cartDrawer,"click",function(event){var tracked=event.target.closest("[data-gh-track]");if(!tracked)return;track(tracked.getAttribute("data-gh-track"),{gh_label:tracked.textContent.trim(),
gh_url:tracked.getAttribute("href")||""
});});listen(document,"pointerdown",function(event){if(!isDesktop())return;if(!header.contains(event.target))closeAllMega();},true);listen(document,"pointerdown",function(event){if(!isDesktop()||!cartDrawer||!cartPanel||!cartDrawer.classList.contains("is-open"))return;if(cartPanel.contains(event.target))return;var clickedOpener=cartOpenButtons.some(function(button){return button&&button.contains(event.target);});if(clickedOpener)return;closeCartDrawer(true);},true);listen(document,"keydown",function(event){if(event.key==="Escape"){if(cartDrawer&&cartDrawer.classList.contains("is-open")){closeCartDrawer(true);}else if(header.classList.contains("is-mobile-open")){closeMobileMenu(true);}else{var openItem=header.querySelector(".gh-mega-header__nav-item--mega.is-open");var openTrigger=openItem ? openItem.querySelector(".gh-mega-header__mega-trigger"):null;closeAllMega();if(openTrigger)openTrigger.focus();}return;}if(cartDrawer&&cartDrawer.classList.contains("is-open")){trapFocus(event,cartPanel);}else if(header.classList.contains("is-mobile-open")){trapFocus(event,mobileNav);}});function handleDesktopBreakpointChange(){closeAllMega();if(isDesktop()&&header.classList.contains("is-mobile-open")){closeMobileMenu(false);}else{updateNavigationAria();}syncMobileStickyBuyWithCartDrawer();}listenMedia(desktopMedia,handleDesktopBreakpointChange);listenMedia(mobileStickyMedia,function(){syncMobileStickyBuyWithCartDrawer();});listenMedia(reduceMotionMedia,function(event){reduceMotion=Boolean(event.matches);});function resetTransientUI(){clearTimer(scheduledCartRefreshTimer);scheduledCartRefreshTimer=null;scheduledCartRefreshOptions=null;clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;abortCartFetch();header.classList.add("gh-no-motion");header.classList.remove(
"is-mobile-open",
"is-cart-pulsing",
"is-navigating"
);if(mobileToggle){mobileToggle.setAttribute("aria-expanded","false");}cartOpenButtons.forEach(function(button){button.setAttribute("aria-expanded","false");});closeAllMega();if(cartDrawer){cartDrawer.classList.add("gh-no-motion");cartDrawer.classList.remove("is-open","is-loading");cartDrawer.setAttribute("aria-hidden","true");cartDrawer.setAttribute("aria-busy","false");cartDrawer.setAttribute("inert","");lastObservedDrawerOpen=false;}sectionRoot&&sectionRoot.classList.remove("gh-layer-active");document.documentElement.classList.remove("gh-overlay-open");document.body.classList.remove(
"gh-overlay-open",
"gh-cart-drawer-mobile-open"
);updateNavigationAria();syncMobileStickyBuyWithCartDrawer();restoreBackgroundInert();window.requestAnimationFrame(function(){window.requestAnimationFrame(function(){header.classList.remove("gh-no-motion");cartDrawer&&cartDrawer.classList.remove("gh-no-motion");});});}listen(window,"pagehide",resetTransientUI);listen(window,"pageshow",function(event){resetTransientUI();if(event.persisted){refreshCart({pulse:false,
renderWhenOpen:false,
force:true,
silent:true
}).catch(function(){});}});listen(document,"submit",function(event){var form=event.target;if (!form || !form.matches("form[action*='/cart/add']")) return;var countAtSubmit=lastCartCount;var fallbackAttempt=0;clearTimer(pendingAddFallbackTimer);var verifySubmittedAdd=function(){pendingAddFallbackTimer=null;if(Date.now()- lastFastAddTime<900)return;fallbackAttempt+=1;refreshCart({pulse:true,
renderWhenOpen:true,
force:true,
silent:true
})
.then(function(cart){if(Date.now()- lastFastAddTime<900)return;if(Number(cart.item_count||0)>countAtSubmit){openCartDrawer({cart:cart,
backgroundRefresh:false,
focusPanel:true
});return;}if(fallbackAttempt<3){pendingAddFallbackTimer=later(verifySubmittedAdd,650 * fallbackAttempt);}})
.catch(function(){if(fallbackAttempt<3&&Date.now()- lastFastAddTime>=900){pendingAddFallbackTimer=later(verifySubmittedAdd,650 * fallbackAttempt);}});};pendingAddFallbackTimer=later(verifySubmittedAdd,700);},true);listen(document,"gh:cart:added",function(event){var detail=event&&event.detail ? event.detail:{};var suppliedCart=detail.cart||(
Array.isArray(detail.items)&&detail.item_count!=null
? detail
:null
);var addedItems=Array.isArray(detail.items)? detail.items:[];var addedItem=detail.item||
(addedItems.length===1&&!suppliedCart ? addedItems[0]:null)||
(detail.id||detail.key ? detail:null);clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;markAddHandled(detail);if(suppliedCart&&Array.isArray(suppliedCart.items)){cartStateVersion+=1;abortCartFetch();cartCache=suppliedCart;cartCacheTime=Date.now();renderCount(Number(suppliedCart.item_count||0),true);openCartDrawer({cart:suppliedCart,
backgroundRefresh:false,
focusPanel:true
});announce(text("cartUpdated","Warenkorb aktualisiert."));return;}if(addedItem&&renderAddedItemInstantly(addedItem)){return;}openCartDrawer({cart:null,
backgroundRefresh:true,
focusPanel:true,
ignoreCache:true
});});listen(document,"gh:cart-refresh",function(event){if(
event&&
event.detail&&
event.detail.open
){openCartDrawer({cart:cartCache,
backgroundRefresh:true,
focusPanel:true
});return;}scheduleCartRefresh({pulse:true,
renderWhenOpen:true,
force:false,
allowFreshCache:false,
silent:true
},100);});[
"cart:updated",
"cart:update",
"cart:refresh",
"product:added",
"ajaxProduct:added",
"theme:cart:change"
].forEach(function(eventName){listen(document,eventName,function(event){var isProductAddedEvent=
eventName==="product:added"||eventName==="ajaxProduct:added";var detail=event&&event.detail ? event.detail:{};var suppliedCart=detail.cart||(
Array.isArray(detail.items)&&detail.item_count!=null
? detail
:null
);if(isProductAddedEvent&&wasAddHandledRecently(detail,900)){return;}if(suppliedCart&&Array.isArray(suppliedCart.items)){cartStateVersion+=1;abortCartFetch();cartCache=suppliedCart;cartCacheTime=Date.now();renderCount(Number(suppliedCart.item_count||0),true);if(isProductAddedEvent){clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;markAddHandled(detail);openCartDrawer({cart:suppliedCart,
backgroundRefresh:false,
focusPanel:true
});}else if(cartDrawer&&cartDrawer.classList.contains("is-open")){renderDrawer(suppliedCart);}}else if(isProductAddedEvent&&(detail.item||detail.id||detail.key)){clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;renderAddedItemInstantly(detail.item||detail);}else if(isProductAddedEvent){clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;markAddHandled(detail);openCartDrawer({cart:null,
backgroundRefresh:true,
focusPanel:true,
ignoreCache:true
});}else{scheduleCartRefresh({pulse:true,
renderWhenOpen:true,
force:false,
allowFreshCache:false,
silent:true
},100);}});});listen(document,"shopify:section:unload",function(event){if(!event.detail||String(event.detail.sectionId||"")!==instanceKey)return;destroy();});listen(document,"shopify:block:select",function(event){if(!event.detail||String(event.detail.sectionId||"")!==instanceKey)return;var selectedBlock=event.target&&event.target.closest
? event.target.closest("[data-shopify-editor-block]")
:null;var selectedMegaItem=selectedBlock
? selectedBlock.closest(".gh-mega-header__nav-item--mega")
:null;if(!selectedMegaItem)return;if(!isDesktop())openMobileMenu();openMega(selectedMegaItem);later(function(){selectedBlock.scrollIntoView({behavior:reduceMotion ? "auto":"smooth",
block:"nearest"
});},40);});function destroy(){controller.abort();abortCartFetch();if(cartChangeController){cartChangeController.abort();cartChangeController=null;}clearTimer(pendingAddFallbackTimer);pendingAddFallbackTimer=null;timers.forEach(function(timer){window.clearTimeout(timer);});timers.clear();header.classList.remove("is-mobile-open","is-cart-pulsing","is-gh-ready");closeAllMega();if(cartDrawer){cartDrawer.classList.remove("is-open","is-loading","is-gh-ready");cartDrawer.setAttribute("aria-hidden","true");cartDrawer.setAttribute("aria-busy","false");cartDrawer.setAttribute("inert","");}cartOpenButtons.forEach(function(button){button.setAttribute("aria-expanded","false");});if(cartDrawerStateObserver){cartDrawerStateObserver.disconnect();cartDrawerStateObserver=null;}setMobileStickyBuyHidden(false);sectionRoot&&sectionRoot.classList.remove("gh-layer-active");document.documentElement.classList.remove("gh-overlay-open");document.body.classList.remove(
"gh-overlay-open",
"gh-cart-drawer-mobile-open"
);restoreBackgroundInert();instances.delete(instanceKey);}var cartDrawerStateObserver=null;if(cartDrawer&&typeof MutationObserver==="function"){cartDrawerStateObserver=new MutationObserver(function(){var drawerIsOpen=cartDrawer.classList.contains("is-open");if(drawerIsOpen!==lastObservedDrawerOpen){lastObservedDrawerOpen=drawerIsOpen;syncMobileStickyBuyWithCartDrawer();syncPageLock();}var needsInitialRender=
cartBody&&
(
!cartBody.firstElementChild||
Boolean(
cartBody.querySelector(
".gh-cart-drawer-root__loading"
)
)
);if(
drawerIsOpen&&
cartCache&&
needsInitialRender
){renderDrawer(cartCache,{announceUpdate:false,
forceRender:true
});if(cartDrawer.classList.contains("is-loading")){cartDrawer.classList.remove("is-loading");}}});cartDrawerStateObserver.observe(cartDrawer,{attributes:true,
attributeFilter:["class","aria-hidden"]
});}instances.set(instanceKey,{destroy:destroy,
refreshExternalElements:function(){refreshMobileStickyBars();syncMobileStickyBuyWithCartDrawer();}});updateNavigationAria();refreshMobileStickyBars();syncMobileStickyBuyWithCartDrawer();header.classList.add("is-gh-ready");cartDrawer&&cartDrawer.classList.add("is-gh-ready");var cartWarmStarted=false;function warmCartCacheOnIntent(){if(
cartWarmStarted||
cartCache||
cartFetchPromise||
signal.aborted
){return;}cartWarmStarted=true;refreshCart({pulse:false,
renderWhenOpen:false,
force:false,
allowFreshCache:true,
silent:true,
announceUpdate:false
})
.catch(function(){cartWarmStarted=false;});}cartOpenButtons.forEach(function(button){listen(button,"pointerenter",warmCartCacheOnIntent,{once:true,
passive:true
});listen(button,"focusin",warmCartCacheOnIntent,{once:true});listen(button,"touchstart",warmCartCacheOnIntent,{once:true,
passive:true
});});}function initAll(scope){collectHeaders(scope||document).forEach(initialise);}function refreshExternalElements(){instances.forEach(function(instance){if(
instance&&
typeof instance.refreshExternalElements==="function"
){instance.refreshExternalElements();}});}window[runtimeKey]={version:runtimeVersion,
initAll:initAll,
refreshExternalElements:refreshExternalElements,
instances:instances
};document.addEventListener("shopify:section:load",function(event){initAll(event.target);refreshExternalElements();});if(document.readyState==="loading"){document.addEventListener(
"DOMContentLoaded",
function(){initAll(document);},
{once:true});}else{initAll(document);}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    (function () {
"use strict";
if (window.__GH_CART_PERSISTENT_RUNTIME_V4__) {
if (typeof window.GHCart1010Init === "function") {
window.GHCart1010Init();
}
return;
}
window.__GH_CART_PERSISTENT_RUNTIME_V4__ = true;
var controllers = new WeakMap();
function shopifyRoot() {
return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
? window.Shopify.routes.root
: "/";
}
function safeNumber(value, fallback) {
var number = Number(value);
return Number.isFinite(number) ? number : fallback;
}
function findItemByLineKey(root, lineKey) {
if (!root || !lineKey)
return null;
return Array.from(root.querySelectorAll(".gh-cart-item")).find(function (item) {
return item.getAttribute("data-gh-cart-line-key") === String(lineKey);
}) || null;
}
function destroyRoot(root) {
var controller = root ? controllers.get(root) : null;
if (!controller)
return;
controller.destroy();
controllers.delete(root);
}
function initRoot(root) {
if (!root || root.getAttribute("data-gh-cart-runtime-ready") === "true")
return;
root.setAttribute("data-gh-cart-runtime-ready", "true");
var sectionId = root.getAttribute("data-gh-section-id") || "";
var rootId = root.id || ("GHCart-"+ sectionId);
var cartUrl = root.getAttribute("data-gh-cart-url") || (shopifyRoot() + "cart");
var moneyFormat = root.getAttribute("data-gh-money-format") || "";
var currencyCode = root.getAttribute("data-gh-currency") || "EUR";
var lifecycle = new AbortController();
var signal = lifecycle.signal;
var requestControllers = new Set();
var automaticVariantTimers = new Map();
var lifecycleTimers = new Set();
var variantDataCache = new WeakMap();
var productVariantDataCache = new Map();
var mutationTail = Promise.resolve();
var isUpdating = false;
var destroyed = false;
function setLifecycleTimeout(callback, delay) {
var timer = window.setTimeout(function () {
lifecycleTimers.delete(timer);
if (destroyed || signal.aborted)
return;
callback();
}, Math.max(0, safeNumber(delay, 0)));
lifecycleTimers.add(timer);
return timer;
}
function setBusy(state) {
isUpdating = Boolean(state);
if (!document.documentElement.contains(root))
return;
root.setAttribute("aria-busy", isUpdating ? "true": "false");
root.classList.toggle("is-gh-cart-updating", isUpdating);
if (isUpdating) {
root
.querySelectorAll("button, input, select")
.forEach(function (control) {
if (!control.disabled) {
control.setAttribute("data-gh-runtime-disabled", "true");
control.disabled = true;
}
});
}
else {
root
.querySelectorAll("[data-gh-runtime-disabled='true']")
.forEach(function (control) {
control.disabled = false;
control.removeAttribute("data-gh-runtime-disabled");
});
}
}
function announce(message) {
var liveRegion = root.querySelector("#cart-live-region-text");
if (!liveRegion)
return;
liveRegion.textContent = "";
window.requestAnimationFrame(function () {
if (document.documentElement.contains(liveRegion)) {
liveRegion.textContent = String(message || "");
}
});
}
function fetchWithTimeout(url, options, timeoutMs) {
var requestOptions = Object.assign({}, options || {});
var controller = new AbortController();
var timedOut = false;
var timeout = window.setTimeout(function () {
timedOut = true;
controller.abort();
}, Math.max(3000, safeNumber(timeoutMs, 12000)));
var abortFromLifecycle = function () {
controller.abort();
};
requestControllers.add(controller);
signal.addEventListener("abort", abortFromLifecycle, { once: true });
requestOptions.signal = controller.signal;
return fetch(url, requestOptions)
.catch(function (error) {
if (error && error.name === "AbortError"&& timedOut) {
error.ghTimedOut = true;
}
throw error;
})
.finally(function () {
window.clearTimeout(timeout);
requestControllers.delete(controller);
signal.removeEventListener("abort", abortFromLifecycle);
});
}
function responseJsonOrError(response, fallbackMessage) {
return response
.json()
.catch(function () {
return {};
})
.then(function (payload) {
if (!response.ok) {
var error = new Error(payload.description ||
payload.message ||
fallbackMessage ||
"Cart request failed");
error.status = response.status;
error.payload = payload;
throw error;
}
return payload;
});
}
function cartSectionPayload(payload) {
var nextPayload = Object.assign({}, payload || {});
nextPayload.sections = sectionId;
nextPayload.sections_url = cartUrl;
return nextPayload;
}
function fetchCartJson() {
return fetchWithTimeout(shopifyRoot() + "cart.js", {
headers: { "Accept": "application/json"}
}).then(function (response) {
return responseJsonOrError(response, "Cart could not be loaded");
});
}
function formatMoney(cents) {
var amount = safeNumber(cents, 0);
if (window.Shopify &&
typeof window.Shopify.formatMoney === "function") {
return window.Shopify.formatMoney(amount, moneyFormat);
}
try {
return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
style: "currency",
currency: currencyCode
}).format(amount / 100);
}
catch (error) {
return (amount / 100).toFixed(2).replace(".", ",") + " €";
}
}
function updateHeaderCartState(cart) {
if (!cart || !Number.isFinite(Number(cart.item_count)))
return;
var count = Number(cart.item_count) || 0;
document
.querySelectorAll("[data-gh-cart-count-bubble]")
.forEach(function (bubble) {
bubble.textContent = String(count);
bubble.classList.toggle("is-active", count > 0);
});
document
.querySelectorAll("[data-gh-cart-status]")
.forEach(function (status) {
status.textContent =
count > 0
? count + " item"+ (count === 1 ? "": "s")
: "Empty";
});
document.dispatchEvent(new CustomEvent("cart:updated", {
detail: {
cart: cart,
source: "gymhawk-cart-page"
}
}));
}
function getCartItem(target) {
return target ? target.closest(".gh-cart-item") : null;
}
function getQuantityInput(item) {
return item
? item.querySelector("input.quantity__input[name='updates[]']")
: null;
}
function getCurrentQuantity(item) {
var input = getQuantityInput(item);
var quantity = input ? parseInt(input.value || "1", 10) : 1;
return Number.isFinite(quantity) ? quantity : 1;
}
function getQuantityRules(item) {
var input = getQuantityInput(item);
var minimum = input
? safeNumber(input.getAttribute("min") || input.getAttribute("data-min"), 1)
: 1;
var maximum = input && input.hasAttribute("max")
? safeNumber(input.getAttribute("max"), null)
: null;
var increment = input
? Math.max(1, safeNumber(input.getAttribute("step"), 1))
: 1;
return {
min: Math.max(1, minimum),
max: maximum !== null ? Math.max(minimum, maximum) : null,
increment: increment
};
}
function normalizeQuantity(quantity, rules, allowZero) {
var value = Math.floor(safeNumber(quantity, 1));
var normalizedRules = rules || { min: 1, max: null, increment: 1 };
if (allowZero && value <= 0)
return 0;
var minimum = Math.max(1, safeNumber(normalizedRules.min, 1));
var increment = Math.max(1, safeNumber(normalizedRules.increment, 1));
var maximum = normalizedRules.max === null ||
normalizedRules.max === undefined ||
normalizedRules.max === ""
? null
: Math.max(minimum, safeNumber(normalizedRules.max, minimum));
value = Math.max(minimum, value);
if (value > minimum) {
value =
minimum +
Math.ceil((value - minimum) / increment) * increment;
}
if (maximum !== null && value > maximum) {
var steps = Math.floor((maximum - minimum) / increment);
value = minimum + Math.max(0, steps) * increment;
}
return value;
}
function normalizeQuantityForVariant(quantity, variant) {
var rule = variant && variant.quantity_rule
? variant.quantity_rule
: { min: 1, max: null, increment: 1 };
return normalizeQuantity(quantity, rule, false);
}
function focusDescriptor(target, item, control, extra) {
var active = document.activeElement;
var shouldRestore = Boolean(target) &&
(active === target ||
(target.contains && target.contains(active)) ||
(item && item.contains(active)));
var identity = item ? lineIdentity(item) : null;
var descriptor = Object.assign({
restore: shouldRestore,
control: control || "",
lineKey: identity ? identity.lineKey : "",
productId: identity ? identity.productId : "",
properties: identity ? identity.properties : {},
sellingPlanId: identity ? identity.sellingPlanId : null,
itemIndex: item
? Array.from(root.querySelectorAll(".gh-cart-item")).indexOf(item)
: -1
}, extra || {});
return descriptor;
}
function restoreFocus(newRoot, descriptor) {
if (!newRoot || !descriptor || !descriptor.restore)
return;
window.requestAnimationFrame(function () {
if (!document.documentElement.contains(newRoot))
return;
var item = findItemByIdentity(newRoot, {
lineKey: descriptor.lineKey || "",
productId: descriptor.productId || "",
variantId: descriptor.variantId || "",
properties: descriptor.properties || {},
sellingPlanId: descriptor.sellingPlanId || null
});
var target = null;
if (descriptor.control === "upsell") {
target = newRoot.querySelector('[data-gh-upsell-add][data-variant-id="'+
String(descriptor.variantId || "").replace(/"/g, '\\"') +
'"]');
}
else if (item) {
if (descriptor.control === "plus") {
target = item.querySelector("button[name='plus']");
}
else if (descriptor.control === "minus") {
target = item.querySelector("button[name='minus']");
}
else if (descriptor.control === "remove") {
target = item.querySelector(".gh-cart-remove[href]");
}
else if (descriptor.control === "quantity") {
target = getQuantityInput(item);
}
else if (descriptor.control === "variant") {
target = item.querySelector('[data-gh-cart-option][data-option-index="'+
String(descriptor.optionIndex || 0) +
'"]');
}
}
if (!target && descriptor.control === "remove") {
var items = Array.from(newRoot.querySelectorAll(".gh-cart-item"));
if (items.length) {
var fallbackIndex = Math.max(0, Math.min(descriptor.itemIndex < 0 ? 0 : descriptor.itemIndex, items.length - 1));
target =
items[fallbackIndex].querySelector("button[name='plus'], button[name='minus'], .gh-cart-item__name") || null;
}
}
if (!target) {
target =
newRoot.querySelector(".gh-checkout-button") ||
newRoot.querySelector(".gh-cart-continue-shopping") ||
newRoot.querySelector(".gh-cart-continue");
}
if (target && typeof target.focus === "function") {
try {
target.focus({ preventScroll: true });
}
catch (error) {
target.focus();
}
}
});
}
function markSuccessfulVariant(newRoot, identity) {
if (!newRoot || !identity)
return;
var item = findItemByIdentity(newRoot, identity);
if (!item)
return;
var status = item.querySelector("[data-gh-cart-variant-status]");
item.classList.add("is-gh-selection-updated");
if (status) {
status.textContent = "Updated ✓";
status.className = "gh-cart-item__variant-status is-success";
}
setLifecycleTimeout(function () {
if (!document.documentElement.contains(item))
return;
item.classList.remove("is-gh-selection-updated");
if (status) {
status.textContent = "Current selection";
status.className = "gh-cart-item__variant-status";
}
}, 2400);
}
function renderBundledCart(payload, options) {
options = options || {};
if (!payload ||
!payload.sections ||
!Object.prototype.hasOwnProperty.call(payload.sections, sectionId)) {
var missingError = new Error("Updated cart section was not returned");
missingError.ghMutationSucceeded = true;
throw missingError;
}
var html = payload.sections[sectionId];
if (!html) {
var renderError = new Error("Updated cart section could not be rendered");
renderError.ghMutationSucceeded = true;
throw renderError;
}
var currentRoot = document.getElementById(rootId);
var savedScrollY = window.scrollY;
var parsed = new DOMParser().parseFromString(html, "text/html");
var freshRoot = parsed.getElementById(rootId);
if (!currentRoot || !freshRoot) {
var rootError = new Error("Updated cart section was not found");
rootError.ghMutationSucceeded = true;
throw rootError;
}
currentRoot.className = freshRoot.className;
currentRoot.innerHTML = freshRoot.innerHTML;
currentRoot.setAttribute("data-gh-cart-runtime-ready", "true");
variantDataCache = new WeakMap();
productVariantDataCache = new Map();
isUpdating = false;
currentRoot.setAttribute("aria-busy", "false");
currentRoot.classList.remove("is-gh-cart-updating");
hydrateVariantEditors();
if (Number.isFinite(Number(payload.item_count))) {
updateHeaderCartState(payload);
}
else {
document.dispatchEvent(new CustomEvent("gh:cart:added", {
detail: {
source: "gymhawk-cart-page",
payload: payload
}
}));
fetchCartJson()
.then(updateHeaderCartState)
.catch(function () {
return undefined;
});
}
if (options.successIdentity) {
markSuccessfulVariant(currentRoot, options.successIdentity);
}
window.scrollTo({
top: savedScrollY,
left: window.scrollX,
behavior: "auto"
});
restoreFocus(currentRoot, options.focus);
return currentRoot;
}
function hardReloadCart(delay) {
setLifecycleTimeout(function () {
window.location.reload();
}, Math.max(0, safeNumber(delay, 0)));
}
function enqueueMutation(task) {
var run = mutationTail
.catch(function () {
return undefined;
})
.then(function () {
if (destroyed || signal.aborted)
return undefined;
return task();
});
mutationTail = run.catch(function () {
return undefined;
});
return run;
}
function mutationRequest(endpoint, payload, options) {
return fetchWithTimeout(shopifyRoot() + endpoint, {
method: "POST",
headers: {
"Content-Type": "application/json",
"Accept": "application/json"
},
body: JSON.stringify(cartSectionPayload(payload))
}, 12000)
.then(function (response) {
return responseJsonOrError(response, "Cart update failed");
})
.then(function (cartPayload) {
renderBundledCart(cartPayload, options || {});
return cartPayload;
});
}
function handleMutationFailure(error, item, rollbackToCurrent) {
if (destroyed)
return;
if (error &&
(error.ghTimedOut ||
error.ghMutationSucceeded)) {
announce("Cart sync required. Reloading…");
hardReloadCart(180);
return;
}
setBusy(false);
if (item && rollbackToCurrent) {
var data = parseVariantEditorData(item);
restoreCurrentVariantPreview(item, data);
}
announce(error && error.message
? error.message
: "Could not update. Please try again.");
}
function updateCartLine(item, quantity, focus, rollbackQuantity) {
if (!item)
return false;
var lineKey = item.getAttribute("data-gh-cart-line-key");
if (!lineKey)
return false;
return enqueueMutation(function () {
setBusy(true);
return mutationRequest("cart/change.js", {
id: lineKey,
quantity: Math.max(0, quantity)
}, { focus: focus }).catch(function (error) {
if (rollbackQuantity !== undefined &&
rollbackQuantity !== null &&
document.documentElement.contains(item)) {
var quantityInput = getQuantityInput(item);
if (quantityInput) {
quantityInput.value = String(rollbackQuantity);
}
}
handleMutationFailure(error, item, false);
return false;
});
});
}
function addVariantToCart(button, variantId, quantity) {
if (!button || !variantId)
return false;
var focus = focusDescriptor(button, null, "upsell", { variantId: String(variantId) });
return enqueueMutation(function () {
setBusy(true);
return mutationRequest("cart/add.js", {
items: [
{
id: Number(variantId),
quantity: Math.max(1, safeNumber(quantity, 1))
}
]
}, { focus: focus }).catch(function (error) {
handleMutationFailure(error, null, false);
return false;
});
});
}
function getProductVariantData(productId) {
var key = String(productId || "");
if (!key)
return [];
if (productVariantDataCache.has(key)) {
return productVariantDataCache.get(key);
}
var node = root.querySelector('[data-gh-cart-product-variant-data][data-product-id="'+
key.replace(/"/g, '\\"') +
'"]');
if (!node) {
productVariantDataCache.set(key, []);
return [];
}
try {
var variants = JSON.parse(node.textContent);
if (!Array.isArray(variants))
variants = [];
productVariantDataCache.set(key, variants);
return variants;
}
catch (error) {
productVariantDataCache.set(key, []);
return [];
}
}
function parseVariantEditorData(item) {
if (!item)
return null;
if (variantDataCache.has(item)) {
return variantDataCache.get(item);
}
var node = item.querySelector("[data-gh-cart-variant-data]");
if (!node)
return null;
try {
var parsedData = JSON.parse(node.textContent);
var productId = parsedData.product_id ||
item.getAttribute("data-gh-product-id") ||
"";
parsedData.product_id = productId;
parsedData.variants = getProductVariantData(productId);
variantDataCache.set(item, parsedData);
return parsedData;
}
catch (error) {
return null;
}
}
function normalizeLineItemProperties(properties) {
var normalized = {};
function assignProperty(key, value) {
if (key === null || key === undefined || key === "")
return;
var safeKey = String(key);
if (safeKey === "__proto__"||
safeKey === "prototype"||
safeKey === "constructor") {
return;
}
normalized[safeKey] = value;
}
if (!properties || typeof properties !== "object") {
return normalized;
}
if (Array.isArray(properties)) {
properties.forEach(function (entry) {
if (Array.isArray(entry) && entry.length >= 2) {
assignProperty(entry[0], entry[1]);
return;
}
if (!entry || typeof entry !== "object")
return;
if (Object.prototype.hasOwnProperty.call(entry, "first") &&
Object.prototype.hasOwnProperty.call(entry, "last")) {
assignProperty(entry.first, entry.last);
return;
}
if (Object.prototype.hasOwnProperty.call(entry, "key") &&
Object.prototype.hasOwnProperty.call(entry, "value")) {
assignProperty(entry.key, entry.value);
return;
}
if (Object.prototype.hasOwnProperty.call(entry, "name") &&
Object.prototype.hasOwnProperty.call(entry, "value")) {
assignProperty(entry.name, entry.value);
return;
}
Object.keys(entry).forEach(function (key) {
assignProperty(key, entry[key]);
});
});
return normalized;
}
Object.keys(properties).forEach(function (key) {
assignProperty(key, properties[key]);
});
return normalized;
}
function comparableProperties(properties) {
var normalized = normalizeLineItemProperties(properties);
return Object.keys(normalized)
.sort()
.map(function (key) {
return [key, normalized[key]];
});
}
function sameProperties(first, second) {
return (JSON.stringify(comparableProperties(first)) ===
JSON.stringify(comparableProperties(second)));
}
function lineIdentity(item, variantId) {
if (!item)
return null;
var data = parseVariantEditorData(item);
return {
lineKey: data && data.line_key
? String(data.line_key)
: item.getAttribute("data-gh-cart-line-key") || "",
productId: item.getAttribute("data-gh-product-id") ||
(data && data.product_id ? String(data.product_id) : ""),
variantId: String(variantId ||
item.getAttribute("data-gh-current-variant-id") ||
(data && data.current_variant_id) ||
""),
properties: data ? normalizeLineItemProperties(data.properties) : {},
sellingPlanId: data && data.selling_plan_id
? Number(data.selling_plan_id) || null
: null
};
}
function findItemByIdentity(searchRoot, identity) {
if (!searchRoot || !identity)
return null;
if (identity.lineKey) {
var byKey = findItemByLineKey(searchRoot, identity.lineKey);
if (byKey)
return byKey;
}
var candidates = Array.from(searchRoot.querySelectorAll(".gh-cart-item")).filter(function (candidate) {
var variantMatches = !identity.variantId ||
candidate.getAttribute("data-gh-current-variant-id") ===
String(identity.variantId);
var productMatches = !identity.productId ||
candidate.getAttribute("data-gh-product-id") ===
String(identity.productId);
return variantMatches && productMatches;
});
if (candidates.length <= 1)
return candidates[0] || null;
return candidates.find(function (candidate) {
var data = parseVariantEditorData(candidate);
if (!data)
return false;
var sellingPlanId = data.selling_plan_id
? Number(data.selling_plan_id) || null
: null;
return (sellingPlanId === (identity.sellingPlanId || null) &&
sameProperties(data.properties || {}, identity.properties || {}));
}) || candidates[0] || null;
}
function lineSellingPlanId(line) {
if (!line)
return null;
if (line.selling_plan_allocation &&
line.selling_plan_allocation.selling_plan) {
return Number(line.selling_plan_allocation.selling_plan.id) || null;
}
return Number(line.selling_plan || line.selling_plan_id) || null;
}
function findMatchingCartLine(cart, newLine) {
if (!cart || !Array.isArray(cart.items) || !newLine)
return null;
var wantedVariantId = String(newLine.id || "");
var wantedSellingPlan = Number(newLine.selling_plan) || null;
var wantedProperties = newLine.properties || {};
return (cart.items.find(function (line) {
var lineVariantId = String(line.variant_id || line.id || "");
return (lineVariantId === wantedVariantId &&
lineSellingPlanId(line) === wantedSellingPlan &&
sameProperties(line.properties || {}, wantedProperties));
}) || null);
}
function addedLineFromResponse(payload) {
if (!payload)
return null;
if (Array.isArray(payload.items))
return payload.items[0] || null;
return payload;
}
function changeCartLineByKey(lineKey, quantity) {
if (!lineKey) {
return Promise.reject(new Error("Rollback line could not be resolved"));
}
return fetchWithTimeout(shopifyRoot() + "cart/change.js", {
method: "POST",
headers: {
"Content-Type": "application/json",
"Accept": "application/json"
},
body: JSON.stringify({
id: lineKey,
quantity: Math.max(0, safeNumber(quantity, 0))
})
}).then(function (response) {
return responseJsonOrError(response, "Cart rollback failed");
});
}
function rollbackAddedVariant(previousMatchingLine, addedLine, newLine) {
var directKey = (addedLine && addedLine.key) ||
(previousMatchingLine && previousMatchingLine.key) ||
"";
var previousQuantity = previousMatchingLine
? Math.max(0, safeNumber(previousMatchingLine.quantity, 0))
: 0;
if (directKey) {
return changeCartLineByKey(directKey, previousQuantity);
}
return fetchCartJson().then(function (cart) {
var currentMatchingLine = findMatchingCartLine(cart, newLine);
if (!currentMatchingLine || !currentMatchingLine.key) {
throw new Error("Rollback line was not found");
}
return changeCartLineByKey(currentMatchingLine.key, previousQuantity);
});
}
function normalizeOptionValue(value) {
return String(value === null || value === undefined ? "": value)
.trim()
.toLocaleLowerCase();
}
function getSelectedOptionValues(item) {
if (!item)
return [];
return Array.from(item.querySelectorAll("[data-gh-cart-option]"))
.sort(function (first, second) {
return (Number(first.getAttribute("data-option-index")) -
Number(second.getAttribute("data-option-index")));
})
.map(function (select) {
return String(select.value || "");
});
}
function variantMatchesValues(variant, selectedValues) {
if (!variant || !Array.isArray(variant.options))
return false;
if (variant.options.length !== selectedValues.length)
return false;
return variant.options.every(function (optionValue, index) {
return (normalizeOptionValue(optionValue) ===
normalizeOptionValue(selectedValues[index]));
});
}
function findSelectedVariant(item, data) {
if (!item || !data || !Array.isArray(data.variants))
return null;
var selectedValues = getSelectedOptionValues(item);
return (data.variants.find(function (variant) {
return variantMatchesValues(variant, selectedValues);
}) || null);
}
function findVariantById(data, variantId) {
if (!data || !Array.isArray(data.variants))
return null;
return (data.variants.find(function (variant) {
return String(variant.id) === String(variantId);
}) || null);
}
function getCandidateVariants(data, selectedValues, optionIndex, candidateValue) {
if (!data || !Array.isArray(data.variants))
return [];
return data.variants.filter(function (variant) {
if (!variant || !Array.isArray(variant.options))
return false;
if (normalizeOptionValue(variant.options[optionIndex]) !==
normalizeOptionValue(candidateValue)) {
return false;
}
for (var index = 0; index < optionIndex; index += 1) {
if (normalizeOptionValue(variant.options[index]) !==
normalizeOptionValue(selectedValues[index])) {
return false;
}
}
return true;
});
}
function updateOptionAvailability(item, data) {
if (!item || !data)
return;
var selects = Array.from(item.querySelectorAll("[data-gh-cart-option]")).sort(function (first, second) {
return (Number(first.getAttribute("data-option-index")) -
Number(second.getAttribute("data-option-index")));
});
var selectedValues = selects.map(function (select) {
return String(select.value || "");
});
selects.forEach(function (select, optionIndex) {
Array.from(select.options).forEach(function (option) {
var candidates = getCandidateVariants(data, selectedValues, optionIndex, option.value);
var hasAvailable = candidates.some(function (variant) {
return variant.available === true;
});
var baseLabel = option.getAttribute("data-gh-base-label") || option.value;
option.disabled = !hasAvailable;
option.setAttribute("aria-disabled", hasAvailable ? "false": "true");
option.textContent = hasAvailable
? baseLabel
: baseLabel + " — Sold out";
});
if (select.selectedOptions[0] &&
select.selectedOptions[0].disabled) {
var firstAvailable = Array.from(select.options).find(function (option) {
return !option.disabled;
});
if (firstAvailable) {
select.value = firstAvailable.value;
selectedValues[optionIndex] = firstAvailable.value;
}
}
else {
selectedValues[optionIndex] = select.value;
}
});
}
function buildVariantProductUrl(productUrl, variantId) {
try {
var url = new URL(productUrl, window.location.origin);
url.searchParams.set("variant", String(variantId));
return url.pathname + url.search + url.hash;
}
catch (error) {
return (String(productUrl || "") +
"?variant="+
encodeURIComponent(variantId));
}
}
function restoreRealLinePrice(item) {
var price = item
? item.querySelector("[data-gh-cart-item-price]")
: null;
if (!price)
return;
if (price.hasAttribute("data-gh-original-price-html")) {
price.innerHTML = price.getAttribute("data-gh-original-price-html");
}
price.classList.remove("is-gh-price-preview");
}
function updatePreviewPrice(item, data, variant, isCurrent) {
var price = item
? item.querySelector("[data-gh-cart-item-price]")
: null;
if (!price || !data || !variant)
return;
if (!price.hasAttribute("data-gh-original-price-html")) {
price.setAttribute("data-gh-original-price-html", price.innerHTML);
}
if (isCurrent) {
restoreRealLinePrice(item);
return;
}
var quantity = Math.max(1, getCurrentQuantity(item));
var linePrice = safeNumber(variant.price, 0) * quantity;
var compareLinePrice = safeNumber(variant.compare_at_price, 0) * quantity;
var priceHtml = formatMoney(linePrice);
if (compareLinePrice > linePrice) {
priceHtml =
'<span><s class="gh-cart-item__old-price">'+
formatMoney(compareLinePrice) +
"</s> "+
priceHtml +
"</span>";
}
else {
priceHtml = "<span>"+ priceHtml + "</span>";
}
price.innerHTML = priceHtml;
price.classList.add("is-gh-price-preview");
}
function updateColorPreview(item, variant) {
if (!item)
return;
var colorPreview = item.querySelector("[data-gh-cart-color-preview]");
if (!colorPreview)
return;
if (variant && variant.image) {
colorPreview.style.backgroundImage =
'url("'+
String(variant.image).replace(/"/g, '\\"') +
'")';
colorPreview.hidden = false;
}
else {
colorPreview.style.backgroundImage = "";
colorPreview.hidden = true;
}
}
function updatePreviewImage(item, data, variant) {
var image = item
? item.querySelector("[data-gh-cart-item-image]")
: null;
if (!image || !variant || !variant.image)
return;
image.sizes =
"(max-width: 749px) 118px, (max-width: 989px) 160px, 210px";
if (variant.image_srcset) {
image.srcset = variant.image_srcset;
}
else {
image.removeAttribute("srcset");
}
image.src = variant.image;
image.alt =
variant.image_alt ||
data.product_title ||
"Product image";
}
function setSelectValuesForVariant(item, variant) {
if (!item || !variant || !Array.isArray(variant.options))
return;
Array.from(item.querySelectorAll("[data-gh-cart-option]"))
.sort(function (first, second) {
return (Number(first.getAttribute("data-option-index")) -
Number(second.getAttribute("data-option-index")));
})
.forEach(function (select, index) {
if (variant.options[index] !== undefined) {
select.value = String(variant.options[index]);
}
});
}
function restoreCurrentVariantPreview(item, data) {
if (!item || !data)
return null;
var currentVariant = findVariantById(data, data.current_variant_id);
if (!currentVariant)
return null;
setSelectValuesForVariant(item, currentVariant);
updateOptionAvailability(item, data);
updatePreviewImage(item, data, currentVariant);
updateColorPreview(item, currentVariant);
restoreRealLinePrice(item);
item
.querySelectorAll("[data-gh-cart-item-link]")
.forEach(function (link) {
link.href = buildVariantProductUrl(data.product_url, currentVariant.id);
});
var previewBadge = item.querySelector("[data-gh-cart-preview-badge]");
if (previewBadge) {
previewBadge.classList.remove("is-visible");
previewBadge.setAttribute("aria-hidden", "true");
}
return currentVariant;
}
function updateVariantPreview(item) {
var data = parseVariantEditorData(item);
var status = item
? item.querySelector("[data-gh-cart-variant-status]")
: null;
var previewBadge = item
? item.querySelector("[data-gh-cart-preview-badge]")
: null;
if (!data || !status)
return null;
updateOptionAvailability(item, data);
var variant = findSelectedVariant(item, data);
if (!variant) {
status.textContent = "Combination unavailable";
status.className =
"gh-cart-item__variant-status is-error";
if (previewBadge) {
previewBadge.classList.remove("is-visible");
previewBadge.setAttribute("aria-hidden", "true");
}
restoreRealLinePrice(item);
return null;
}
item.classList.add("is-gh-variant-previewing");
updatePreviewImage(item, data, variant);
updateColorPreview(item, variant);
var selectedUrl = buildVariantProductUrl(data.product_url, variant.id);
item
.querySelectorAll("[data-gh-cart-item-link]")
.forEach(function (link) {
link.href = selectedUrl;
});
setLifecycleTimeout(function () {
if (document.documentElement.contains(item)) {
item.classList.remove("is-gh-variant-previewing");
}
}, 160);
var isCurrent = String(variant.id) === String(data.current_variant_id);
updatePreviewPrice(item, data, variant, isCurrent);
if (previewBadge) {
previewBadge.classList.toggle("is-visible", !isCurrent);
previewBadge.setAttribute("aria-hidden", isCurrent ? "true": "false");
}
if (isCurrent) {
status.textContent = "Current selection";
status.className = "gh-cart-item__variant-status";
return variant;
}
if (!variant.available) {
status.textContent = "Sold out";
status.className =
"gh-cart-item__variant-status is-sold-out";
return variant;
}
status.textContent = "Updating automatically…";
status.className =
"gh-cart-item__variant-status is-queued";
return variant;
}
function getAutomaticVariantTimerKey(item, data) {
if (data && data.line_key)
return String(data.line_key);
return item && item.id ? item.id : "cart-item";
}
function clearAutomaticVariantTimer(item, data) {
var key = getAutomaticVariantTimerKey(item, data);
var timer = automaticVariantTimers.get(key);
if (timer) {
window.clearTimeout(timer);
automaticVariantTimers.delete(key);
}
}
function scheduleAutomaticVariantUpdate(item, variant, optionIndex) {
if (!item)
return false;
var data = parseVariantEditorData(item);
var status = item.querySelector("[data-gh-cart-variant-status]");
clearAutomaticVariantTimer(item, data);
if (!data || !variant)
return false;
if (String(variant.id) === String(data.current_variant_id) ||
!variant.available) {
return false;
}
var key = getAutomaticVariantTimerKey(item, data);
var lineKey = String(data.line_key || "");
var productId = item.getAttribute("data-gh-product-id") || "";
var variantId = String(variant.id);
var timer = window.setTimeout(function () {
automaticVariantTimers.delete(key);
enqueueMutation(function () {
var currentRoot = document.getElementById(rootId);
var currentItem = findItemByLineKey(currentRoot, lineKey);
if (!currentItem)
return undefined;
var latestData = parseVariantEditorData(currentItem);
var latestVariant = findVariantById(latestData, variantId);
if (!latestData ||
!latestVariant ||
!latestVariant.available ||
String(latestVariant.id) ===
String(latestData.current_variant_id)) {
updateVariantPreview(currentItem);
return undefined;
}
var activeSelect = currentItem.querySelector('[data-gh-cart-option][data-option-index="'+
String(optionIndex || 0) +
'"]');
return replaceCartVariant(currentItem, latestVariant, focusDescriptor(activeSelect || currentItem, currentItem, "variant", {
optionIndex: optionIndex || 0,
variantId: latestVariant.id,
productId: productId
}));
});
}, 650);
automaticVariantTimers.set(key, timer);
if (status) {
status.textContent = "Updating automatically…";
status.className =
"gh-cart-item__variant-status is-queued";
}
return true;
}
function replaceCartVariant(item, variant, focus) {
if (!item || !variant || !variant.available) {
return Promise.resolve(false);
}
var data = parseVariantEditorData(item);
var status = item.querySelector("[data-gh-cart-variant-status]");
if (!data || !data.line_key) {
return Promise.resolve(false);
}
if (String(variant.id) === String(data.current_variant_id)) {
return Promise.resolve(false);
}
var newLine = {
id: Number(variant.id),
quantity: normalizeQuantityForVariant(Math.max(1, safeNumber(data.quantity, 1)), variant)
};
var normalizedProperties = normalizeLineItemProperties(data.properties);
if (Object.keys(normalizedProperties).length) {
newLine.properties = normalizedProperties;
}
if (data.selling_plan_id) {
newLine.selling_plan = Number(data.selling_plan_id);
}
setBusy(true);
item
.querySelectorAll("[data-gh-cart-option]")
.forEach(function (select) {
select.disabled = true;
});
if (status) {
status.textContent = "Updating…";
status.className =
"gh-cart-item__variant-status is-updating";
}
var previousMatchingLine = null;
var addedLine = null;
var oldLineRemoved = false;
return fetchCartJson()
.then(function (cartBeforeChange) {
previousMatchingLine = findMatchingCartLine(cartBeforeChange, newLine);
return fetchWithTimeout(shopifyRoot() + "cart/add.js", {
method: "POST",
headers: {
"Content-Type": "application/json",
"Accept": "application/json"
},
body: JSON.stringify({
items: [newLine]
})
}, 12000);
})
.then(function (response) {
return responseJsonOrError(response, "Variant could not be added");
})
.then(function (addPayload) {
addedLine = addedLineFromResponse(addPayload);
return fetchWithTimeout(shopifyRoot() + "cart/change.js", {
method: "POST",
headers: {
"Content-Type": "application/json",
"Accept": "application/json"
},
body: JSON.stringify(cartSectionPayload({
id: data.line_key,
quantity: 0
}))
}, 12000);
})
.then(function (response) {
return responseJsonOrError(response, "Old variant could not be removed");
})
.then(function (cartPayload) {
oldLineRemoved = true;
renderBundledCart(cartPayload, {
focus: focus,
successIdentity: lineIdentity(item, variant.id)
});
return true;
})
.catch(function (error) {
if (error &&
(error.ghTimedOut ||
error.ghMutationSucceeded)) {
announce("Cart sync required. Reloading…");
hardReloadCart(180);
return false;
}
if (!addedLine || oldLineRemoved) {
setBusy(false);
restoreCurrentVariantPreview(item, data);
if (status) {
status.textContent =
error && error.message
? error.message
: "Could not update. Please try again.";
status.className =
"gh-cart-item__variant-status is-error";
}
return false;
}
return rollbackAddedVariant(previousMatchingLine, addedLine, newLine)
.then(function () {
announce("Update failed. Previous selection restored. Reloading…");
hardReloadCart(220);
return false;
})
.catch(function () {
announce("Cart sync required. Reloading…");
hardReloadCart(120);
return false;
});
});
}
root.addEventListener("click", function (event) {
if (isUpdating) {
var blockedInteractive = event.target.closest("a, button, input, select");
if (blockedInteractive && root.contains(blockedInteractive)) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
return false;
}
}
var plusButton = event.target.closest("button[name='plus']");
var minusButton = event.target.closest("button[name='minus']");
var removeLink = event.target.closest(".gh-cart-remove[href], cart-remove-button a[href]");
var upsellButton = event.target.closest("[data-gh-upsell-add][data-variant-id]");
if (!plusButton &&
!minusButton &&
!removeLink &&
!upsellButton) {
return;
}
if (upsellButton && root.contains(upsellButton)) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
addVariantToCart(upsellButton, upsellButton.getAttribute("data-variant-id"), 1);
return false;
}
var item = getCartItem(event.target);
if (!item)
return;
var currentQuantity = getCurrentQuantity(item);
var rules = getQuantityRules(item);
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
if (plusButton) {
var plusQuantity = currentQuantity + rules.increment;
if (rules.max !== null &&
plusQuantity > rules.max) {
announce("Maximum quantity reached.");
return false;
}
updateCartLine(item, normalizeQuantity(plusQuantity, rules, false), focusDescriptor(plusButton, item, "plus"));
return false;
}
if (minusButton) {
var minusQuantity = currentQuantity - rules.increment;
if (minusQuantity < rules.min) {
minusQuantity = 0;
}
else {
minusQuantity = normalizeQuantity(minusQuantity, rules, false);
}
updateCartLine(item, minusQuantity, focusDescriptor(minusButton, item, "minus"));
return false;
}
if (removeLink) {
updateCartLine(item, 0, focusDescriptor(removeLink, item, "remove"));
return false;
}
}, { capture: true, signal: signal });
root.addEventListener("change", function (event) {
if (isUpdating) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
return false;
}
var variantSelect = event.target.closest("[data-gh-cart-option]");
if (variantSelect && root.contains(variantSelect)) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
var variantItem = getCartItem(variantSelect);
var selectedVariant = updateVariantPreview(variantItem);
scheduleAutomaticVariantUpdate(variantItem, selectedVariant, Number(variantSelect.getAttribute("data-option-index")) || 0);
return false;
}
var input = event.target.closest("input.quantity__input[name='updates[]']");
if (!input || !root.contains(input))
return;
var item = getCartItem(input);
if (!item)
return;
var rules = getQuantityRules(item);
var previousQuantity = safeNumber(item.getAttribute("data-gh-line-quantity"), 1);
var rawQuantity = parseInt(input.value || "1", 10);
var newQuantity = Number.isFinite(rawQuantity) && rawQuantity <= 0
? 0
: normalizeQuantity(rawQuantity, rules, false);
input.value = String(newQuantity);
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
updateCartLine(item, newQuantity, focusDescriptor(input, item, "quantity"), previousQuantity);
return false;
}, { capture: true, signal: signal });
function hydrateVariantEditors() {
root
.querySelectorAll(".gh-cart-item")
.forEach(function (item) {
if (item.querySelector("[data-gh-cart-variant-editor]")) {
updateVariantPreview(item);
}
});
}
hydrateVariantEditors();
var controller = {
destroy: function () {
if (destroyed)
return;
destroyed = true;
automaticVariantTimers.forEach(function (timer) {
window.clearTimeout(timer);
});
automaticVariantTimers.clear();
lifecycleTimers.forEach(function (timer) {
window.clearTimeout(timer);
});
lifecycleTimers.clear();
productVariantDataCache.clear();
variantDataCache = new WeakMap();
requestControllers.forEach(function (controller) {
controller.abort();
});
requestControllers.clear();
lifecycle.abort();
if (document.documentElement.contains(root)) {
root.removeAttribute("data-gh-cart-runtime-ready");
root.removeAttribute("aria-busy");
root.classList.remove("is-gh-cart-updating");
}
}
};
controllers.set(root, controller);
}
function scan(scope) {
var base = scope || document;
if (base.nodeType === 1 &&
base.matches &&
base.matches("[data-gh-cart-root]")) {
initRoot(base);
}
if (base.querySelectorAll) {
base
.querySelectorAll("[data-gh-cart-root]")
.forEach(initRoot);
}
}
function boot() {
scan(document);
}
window.GHCart1010Init = boot;
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", boot, { once: true });
}
else {
boot();
}
document.addEventListener("shopify:section:load", function (event) {
scan(event.target);
});
document.addEventListener("shopify:section:unload", function (event) {
if (!event.target)
return;
if (event.target.matches &&
event.target.matches("[data-gh-cart-root]")) {
destroyRoot(event.target);
}
if (event.target.querySelectorAll) {
event.target
.querySelectorAll("[data-gh-cart-root]")
.forEach(destroyRoot);
}
});
})();
  } catch(e) { console.error(e); }
})();
})();
